
import {Content} from './schema';
export const CONTENT: Content = {
		"series": [
				{
						"linkName": "blind-choices",
						"name": "Blind Choices",
						"type": "Drawing",
						"copy": "<h2>BLIND CHOICES</h2>\n<p>These works are based on unseen studio performances. Registering actions and mannerisms observed in my daily life, I re-enact them, using time-lapse photography to capture each pose adopted. It\u2019s the residual echo of a movement\u2019s previous context that interest me, what\u2019s left when all other narrative prompts have been removed.</p>\n<p>Previously I have tended to discard any image not directly related to the original source. Lately though, I find myself intrigued by the accidental stills arising as I get into pose. The drawings are made from composites of these unintended captures.</p>",
						"current": true,
						"coverImage": {
								"fallbackImageUrl": "https://images.tonyhull.com/1024/4VX2nv0YDIQtnslHVohjdh.jpg",
								"imageSizes": [
										{
												"url": "https://images.tonyhull.com/320/4VX2nv0YDIQtnslHVohjdh.jpg",
												"width": 320
										},
										{
												"url": "https://images.tonyhull.com/768/4VX2nv0YDIQtnslHVohjdh.jpg",
												"width": 768
										},
										{
												"url": "https://images.tonyhull.com/640/4VX2nv0YDIQtnslHVohjdh.jpg",
												"width": 640
										},
										{
												"url": "https://images.tonyhull.com/1024/4VX2nv0YDIQtnslHVohjdh.jpg",
												"width": 1024
										},
										{
												"url": "https://images.tonyhull.com/1600/4VX2nv0YDIQtnslHVohjdh.jpg",
												"width": 1600
										},
										{
												"url": "https://images.tonyhull.com/1920/4VX2nv0YDIQtnslHVohjdh.jpg",
												"width": 1920
										},
										{
												"url": "https://images.tonyhull.com/1366/4VX2nv0YDIQtnslHVohjdh.jpg",
												"width": 1366
										}
								]
						},
						"pieces": [
								{
										"title": "Split",
										"year": 2024,
										"medium": "charcoal, Indian ink, emulsion and acrylic on Fabriano",
										"dimensions": "35 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/nhnccghYS4JgyqIA2W57p.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/nhnccghYS4JgyqIA2W57p.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/nhnccghYS4JgyqIA2W57p.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/nhnccghYS4JgyqIA2W57p.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/nhnccghYS4JgyqIA2W57p.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/nhnccghYS4JgyqIA2W57p.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/nhnccghYS4JgyqIA2W57p.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/nhnccghYS4JgyqIA2W57p.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Stay of Execution",
										"year": 2024,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": " 35 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/4OJm3y2yCyPFbFhGZBqHnw.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/4OJm3y2yCyPFbFhGZBqHnw.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/4OJm3y2yCyPFbFhGZBqHnw.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/4OJm3y2yCyPFbFhGZBqHnw.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/4OJm3y2yCyPFbFhGZBqHnw.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/4OJm3y2yCyPFbFhGZBqHnw.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/4OJm3y2yCyPFbFhGZBqHnw.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/4OJm3y2yCyPFbFhGZBqHnw.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Postcard Drawing 8",
										"year": 2024,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "15 x 11cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/3MeB3b0ljAW7pZZo7tX7vJ.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/3MeB3b0ljAW7pZZo7tX7vJ.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/3MeB3b0ljAW7pZZo7tX7vJ.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/3MeB3b0ljAW7pZZo7tX7vJ.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/3MeB3b0ljAW7pZZo7tX7vJ.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/3MeB3b0ljAW7pZZo7tX7vJ.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/3MeB3b0ljAW7pZZo7tX7vJ.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/3MeB3b0ljAW7pZZo7tX7vJ.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Epiphany",
										"year": 2024,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "18 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/1vFqw9tTdCBepJy7uOsemI.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/1vFqw9tTdCBepJy7uOsemI.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/1vFqw9tTdCBepJy7uOsemI.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/1vFqw9tTdCBepJy7uOsemI.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/1vFqw9tTdCBepJy7uOsemI.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/1vFqw9tTdCBepJy7uOsemI.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/1vFqw9tTdCBepJy7uOsemI.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/1vFqw9tTdCBepJy7uOsemI.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "November",
										"year": 2024,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "25 x 17.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/6oKhgI7qc09E75WRbiAs70.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/6oKhgI7qc09E75WRbiAs70.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/6oKhgI7qc09E75WRbiAs70.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/6oKhgI7qc09E75WRbiAs70.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/6oKhgI7qc09E75WRbiAs70.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/6oKhgI7qc09E75WRbiAs70.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/6oKhgI7qc09E75WRbiAs70.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/6oKhgI7qc09E75WRbiAs70.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Surrender",
										"year": 2024,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "25 x 18cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/6xy6tCWdjVaDBZrROnLcd0.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/6xy6tCWdjVaDBZrROnLcd0.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/6xy6tCWdjVaDBZrROnLcd0.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/6xy6tCWdjVaDBZrROnLcd0.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/6xy6tCWdjVaDBZrROnLcd0.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/6xy6tCWdjVaDBZrROnLcd0.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/6xy6tCWdjVaDBZrROnLcd0.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/6xy6tCWdjVaDBZrROnLcd0.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Postcard Drawing 1",
										"year": 2024,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "11 x 15cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/543xFznkv6o84pUnRLsf9.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/543xFznkv6o84pUnRLsf9.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/543xFznkv6o84pUnRLsf9.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/543xFznkv6o84pUnRLsf9.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/543xFznkv6o84pUnRLsf9.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/543xFznkv6o84pUnRLsf9.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/543xFznkv6o84pUnRLsf9.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/543xFznkv6o84pUnRLsf9.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Strider",
										"year": 2024,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "35 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/257duKUhoZM3tNuKVZUeM7.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/257duKUhoZM3tNuKVZUeM7.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/257duKUhoZM3tNuKVZUeM7.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/257duKUhoZM3tNuKVZUeM7.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/257duKUhoZM3tNuKVZUeM7.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/257duKUhoZM3tNuKVZUeM7.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/257duKUhoZM3tNuKVZUeM7.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/257duKUhoZM3tNuKVZUeM7.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Meat Puppet",
										"year": 2024,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "25 x 17.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/5aGPNxl4qfvpjoMJOF3IPP.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/5aGPNxl4qfvpjoMJOF3IPP.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/5aGPNxl4qfvpjoMJOF3IPP.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/5aGPNxl4qfvpjoMJOF3IPP.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/5aGPNxl4qfvpjoMJOF3IPP.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/5aGPNxl4qfvpjoMJOF3IPP.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/5aGPNxl4qfvpjoMJOF3IPP.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/5aGPNxl4qfvpjoMJOF3IPP.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Acquiesce",
										"year": 2024,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "17.5 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/HzHIO99sVztLS3H1KFXu5.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/HzHIO99sVztLS3H1KFXu5.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/HzHIO99sVztLS3H1KFXu5.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/HzHIO99sVztLS3H1KFXu5.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/HzHIO99sVztLS3H1KFXu5.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/HzHIO99sVztLS3H1KFXu5.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/HzHIO99sVztLS3H1KFXu5.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/HzHIO99sVztLS3H1KFXu5.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Postcard Drawing 2",
										"year": 2024,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "11 x 15cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/2SF8N1v7CgAStdIpVm0FU6.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/2SF8N1v7CgAStdIpVm0FU6.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/2SF8N1v7CgAStdIpVm0FU6.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/2SF8N1v7CgAStdIpVm0FU6.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/2SF8N1v7CgAStdIpVm0FU6.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/2SF8N1v7CgAStdIpVm0FU6.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/2SF8N1v7CgAStdIpVm0FU6.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/2SF8N1v7CgAStdIpVm0FU6.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Opening Gambit",
										"year": 2024,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "25 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/4GuJ1jG1cLBFawUh6820mo.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/4GuJ1jG1cLBFawUh6820mo.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/4GuJ1jG1cLBFawUh6820mo.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/4GuJ1jG1cLBFawUh6820mo.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/4GuJ1jG1cLBFawUh6820mo.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/4GuJ1jG1cLBFawUh6820mo.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/4GuJ1jG1cLBFawUh6820mo.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/4GuJ1jG1cLBFawUh6820mo.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Postcard Drawing 5",
										"year": 2024,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "15.5 x 11cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/4iu9aAKytI68uZuD2xWU6o.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/4iu9aAKytI68uZuD2xWU6o.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/4iu9aAKytI68uZuD2xWU6o.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/4iu9aAKytI68uZuD2xWU6o.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/4iu9aAKytI68uZuD2xWU6o.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/4iu9aAKytI68uZuD2xWU6o.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/4iu9aAKytI68uZuD2xWU6o.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/4iu9aAKytI68uZuD2xWU6o.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Postcard Drawing 7",
										"year": 2024,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "15 x 11cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/EZnpR709f91VJhaxPCLQQ.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/EZnpR709f91VJhaxPCLQQ.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/EZnpR709f91VJhaxPCLQQ.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/EZnpR709f91VJhaxPCLQQ.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/EZnpR709f91VJhaxPCLQQ.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/EZnpR709f91VJhaxPCLQQ.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/EZnpR709f91VJhaxPCLQQ.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/EZnpR709f91VJhaxPCLQQ.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Postcard Drawing 6",
										"year": 2024,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "15.5 x 12cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/7s8LM8M2nke5ODw0MOJ2xQ.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/7s8LM8M2nke5ODw0MOJ2xQ.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/7s8LM8M2nke5ODw0MOJ2xQ.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/7s8LM8M2nke5ODw0MOJ2xQ.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/7s8LM8M2nke5ODw0MOJ2xQ.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/7s8LM8M2nke5ODw0MOJ2xQ.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/7s8LM8M2nke5ODw0MOJ2xQ.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/7s8LM8M2nke5ODw0MOJ2xQ.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Postcard Drawing 9 ",
										"year": 2024,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "15.5 x 11cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/7hCgXLNqPFWhm6RWLFUsdM.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/7hCgXLNqPFWhm6RWLFUsdM.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/7hCgXLNqPFWhm6RWLFUsdM.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/7hCgXLNqPFWhm6RWLFUsdM.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/7hCgXLNqPFWhm6RWLFUsdM.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/7hCgXLNqPFWhm6RWLFUsdM.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/7hCgXLNqPFWhm6RWLFUsdM.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/7hCgXLNqPFWhm6RWLFUsdM.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Postcard Drawing 4",
										"year": 2024,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "11.5 x 15cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/4aVrpFelyCXmHx01RvQkK5.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/4aVrpFelyCXmHx01RvQkK5.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/4aVrpFelyCXmHx01RvQkK5.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/4aVrpFelyCXmHx01RvQkK5.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/4aVrpFelyCXmHx01RvQkK5.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/4aVrpFelyCXmHx01RvQkK5.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/4aVrpFelyCXmHx01RvQkK5.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/4aVrpFelyCXmHx01RvQkK5.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Postcard Drawing 10",
										"year": 2024,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "10.5 x 14cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/17Xpe0BomAQ5kjqPk01BUq.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/17Xpe0BomAQ5kjqPk01BUq.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/17Xpe0BomAQ5kjqPk01BUq.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/17Xpe0BomAQ5kjqPk01BUq.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/17Xpe0BomAQ5kjqPk01BUq.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/17Xpe0BomAQ5kjqPk01BUq.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/17Xpe0BomAQ5kjqPk01BUq.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/17Xpe0BomAQ5kjqPk01BUq.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Postcard Drawing 3",
										"year": 2024,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "11 x 15cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/7hK2bv5SHKU2w5kP8iTrSV.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/7hK2bv5SHKU2w5kP8iTrSV.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/7hK2bv5SHKU2w5kP8iTrSV.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/7hK2bv5SHKU2w5kP8iTrSV.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/7hK2bv5SHKU2w5kP8iTrSV.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/7hK2bv5SHKU2w5kP8iTrSV.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/7hK2bv5SHKU2w5kP8iTrSV.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/7hK2bv5SHKU2w5kP8iTrSV.jpg",
																"width": 1366
														}
												]
										}
								}
						],
						"archive": false
				},
				{
						"linkName": "side-steps",
						"name": "Side Steps",
						"type": "Painting",
						"copy": "<h2>SIDE STEPS</h2>\n<p>These oil paint objects are derived from drawings I make in response to unseen studio performances. In these performances I re-enact the actions or mannerisms of others I\u2019ve noticed in my daily life. It\u2019s the extent to which these gestures can reach back to their original context that intrigues me.</p>\n<p>Working from each drawing, I find myself reflecting not only on the image, but also on the physical act of making itself, repeating some of these gestures as I paint. The focus on the \u2018how\u2019 rather than the \u2018what\u2019 of painting is intrinsic to how these works develop. And because the oil paint tablets I work on remain in flux until completely dry, there is always the threat that surface abrasions, creases or pock marks will subsume each representation. I enjoy this tension between the physical presence of the paint object and its image, and that both are made of the same matter.</p>",
						"current": true,
						"coverImage": {
								"fallbackImageUrl": "https://images.tonyhull.com/1024/34L6RdOZ24gRlbhYpxuycC.jpg",
								"imageSizes": [
										{
												"url": "https://images.tonyhull.com/320/34L6RdOZ24gRlbhYpxuycC.jpg",
												"width": 320
										},
										{
												"url": "https://images.tonyhull.com/768/34L6RdOZ24gRlbhYpxuycC.jpg",
												"width": 768
										},
										{
												"url": "https://images.tonyhull.com/640/34L6RdOZ24gRlbhYpxuycC.jpg",
												"width": 640
										},
										{
												"url": "https://images.tonyhull.com/1024/34L6RdOZ24gRlbhYpxuycC.jpg",
												"width": 1024
										},
										{
												"url": "https://images.tonyhull.com/1600/34L6RdOZ24gRlbhYpxuycC.jpg",
												"width": 1600
										},
										{
												"url": "https://images.tonyhull.com/1920/34L6RdOZ24gRlbhYpxuycC.jpg",
												"width": 1920
										},
										{
												"url": "https://images.tonyhull.com/1366/34L6RdOZ24gRlbhYpxuycC.jpg",
												"width": 1366
										}
								]
						},
						"pieces": [
								{
										"title": "Absolved",
										"year": 2024,
										"medium": "oil on oil paint tablet",
										"dimensions": " 28 x 16cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/2UxTMdPpdLLWWarjuD5z5F.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/2UxTMdPpdLLWWarjuD5z5F.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/2UxTMdPpdLLWWarjuD5z5F.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/2UxTMdPpdLLWWarjuD5z5F.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/2UxTMdPpdLLWWarjuD5z5F.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/2UxTMdPpdLLWWarjuD5z5F.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/2UxTMdPpdLLWWarjuD5z5F.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/2UxTMdPpdLLWWarjuD5z5F.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Blind Choice",
										"year": 2024,
										"medium": "oil on oil paint tablet",
										"dimensions": "33.5 x 24.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/47wlvrY9bCmqAv7vHDzmd7.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/47wlvrY9bCmqAv7vHDzmd7.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/47wlvrY9bCmqAv7vHDzmd7.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/47wlvrY9bCmqAv7vHDzmd7.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/47wlvrY9bCmqAv7vHDzmd7.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/47wlvrY9bCmqAv7vHDzmd7.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/47wlvrY9bCmqAv7vHDzmd7.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/47wlvrY9bCmqAv7vHDzmd7.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Departure",
										"year": 2024,
										"medium": "oil on oil paint tablet",
										"dimensions": "21.5 x 22.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/1F4zm0UMRKPWeysNJkHhXs.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/1F4zm0UMRKPWeysNJkHhXs.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/1F4zm0UMRKPWeysNJkHhXs.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/1F4zm0UMRKPWeysNJkHhXs.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/1F4zm0UMRKPWeysNJkHhXs.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/1F4zm0UMRKPWeysNJkHhXs.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/1F4zm0UMRKPWeysNJkHhXs.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/1F4zm0UMRKPWeysNJkHhXs.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Estranged",
										"year": 2024,
										"medium": "oil on oil paint tablet",
										"dimensions": "44 x 30.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/43RdZB6HjhB7jZAU1nHYck.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/43RdZB6HjhB7jZAU1nHYck.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/43RdZB6HjhB7jZAU1nHYck.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/43RdZB6HjhB7jZAU1nHYck.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/43RdZB6HjhB7jZAU1nHYck.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/43RdZB6HjhB7jZAU1nHYck.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/43RdZB6HjhB7jZAU1nHYck.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/43RdZB6HjhB7jZAU1nHYck.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Impasse",
										"year": 2024,
										"medium": "oil on oil paint tablet",
										"dimensions": "16.5 x 29cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/7JVGh7Dxsn7skO6haKw9DG.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/7JVGh7Dxsn7skO6haKw9DG.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/7JVGh7Dxsn7skO6haKw9DG.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/7JVGh7Dxsn7skO6haKw9DG.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/7JVGh7Dxsn7skO6haKw9DG.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/7JVGh7Dxsn7skO6haKw9DG.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/7JVGh7Dxsn7skO6haKw9DG.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/7JVGh7Dxsn7skO6haKw9DG.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Daddy Long Legs",
										"year": 2024,
										"medium": "oil on oil paint tablet",
										"dimensions": "16.5 x 29cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/5W6ifeuLlpg3uRou4rgF8P.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/5W6ifeuLlpg3uRou4rgF8P.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/5W6ifeuLlpg3uRou4rgF8P.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/5W6ifeuLlpg3uRou4rgF8P.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/5W6ifeuLlpg3uRou4rgF8P.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/5W6ifeuLlpg3uRou4rgF8P.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/5W6ifeuLlpg3uRou4rgF8P.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/5W6ifeuLlpg3uRou4rgF8P.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Loss and Its Inverse",
										"year": 2024,
										"medium": "oil on oil paint tablet",
										"dimensions": "22 x 21.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/6qLbNyaTkC9oudz9C1Ks2W.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/6qLbNyaTkC9oudz9C1Ks2W.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/6qLbNyaTkC9oudz9C1Ks2W.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/6qLbNyaTkC9oudz9C1Ks2W.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/6qLbNyaTkC9oudz9C1Ks2W.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/6qLbNyaTkC9oudz9C1Ks2W.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/6qLbNyaTkC9oudz9C1Ks2W.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/6qLbNyaTkC9oudz9C1Ks2W.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "In Consequence",
										"year": 2024,
										"medium": "oil on oil paint tablet",
										"dimensions": "44 x 31cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/3Th9f7R5SXhvAZiX5owwTR.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/3Th9f7R5SXhvAZiX5owwTR.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/3Th9f7R5SXhvAZiX5owwTR.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/3Th9f7R5SXhvAZiX5owwTR.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/3Th9f7R5SXhvAZiX5owwTR.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/3Th9f7R5SXhvAZiX5owwTR.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/3Th9f7R5SXhvAZiX5owwTR.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/3Th9f7R5SXhvAZiX5owwTR.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "In Wilderness",
										"year": 2024,
										"medium": "oil on oil paint tablet",
										"dimensions": "28 x 17cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/43516qPki8EwkaD4yFDz33.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/43516qPki8EwkaD4yFDz33.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/43516qPki8EwkaD4yFDz33.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/43516qPki8EwkaD4yFDz33.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/43516qPki8EwkaD4yFDz33.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/43516qPki8EwkaD4yFDz33.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/43516qPki8EwkaD4yFDz33.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/43516qPki8EwkaD4yFDz33.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Postcard Painting 1",
										"year": 2023,
										"medium": "oil on oil paint tablet",
										"dimensions": "15 x 10.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/6lzophtooUloKhsPujnpju.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/6lzophtooUloKhsPujnpju.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/6lzophtooUloKhsPujnpju.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/6lzophtooUloKhsPujnpju.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/6lzophtooUloKhsPujnpju.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/6lzophtooUloKhsPujnpju.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/6lzophtooUloKhsPujnpju.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/6lzophtooUloKhsPujnpju.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Without You",
										"year": 2024,
										"medium": "oil on oil paint tablet",
										"dimensions": "16.5 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/3nuADvxZEzkMGosTSVhBSK.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/3nuADvxZEzkMGosTSVhBSK.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/3nuADvxZEzkMGosTSVhBSK.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/3nuADvxZEzkMGosTSVhBSK.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/3nuADvxZEzkMGosTSVhBSK.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/3nuADvxZEzkMGosTSVhBSK.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/3nuADvxZEzkMGosTSVhBSK.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/3nuADvxZEzkMGosTSVhBSK.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Postcard Painting 4",
										"year": 2023,
										"medium": "oil on oil paint tablet",
										"dimensions": "15 x 10.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/7uIzbrCBBKgDHetNkiHElE.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/7uIzbrCBBKgDHetNkiHElE.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/7uIzbrCBBKgDHetNkiHElE.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/7uIzbrCBBKgDHetNkiHElE.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/7uIzbrCBBKgDHetNkiHElE.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/7uIzbrCBBKgDHetNkiHElE.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/7uIzbrCBBKgDHetNkiHElE.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/7uIzbrCBBKgDHetNkiHElE.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Postcard Painting 2",
										"year": 2023,
										"medium": "oil on oil paint tablet",
										"dimensions": "15 x 10.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/2DvSmOhzO4PsCFMcNggJFA.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/2DvSmOhzO4PsCFMcNggJFA.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/2DvSmOhzO4PsCFMcNggJFA.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/2DvSmOhzO4PsCFMcNggJFA.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/2DvSmOhzO4PsCFMcNggJFA.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/2DvSmOhzO4PsCFMcNggJFA.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/2DvSmOhzO4PsCFMcNggJFA.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/2DvSmOhzO4PsCFMcNggJFA.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Unscripted",
										"year": 2024,
										"medium": "oil on oil paint tablet",
										"dimensions": "16 x 29cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/6YS27jl7jDBvsuZCmAVHuT.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/6YS27jl7jDBvsuZCmAVHuT.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/6YS27jl7jDBvsuZCmAVHuT.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/6YS27jl7jDBvsuZCmAVHuT.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/6YS27jl7jDBvsuZCmAVHuT.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/6YS27jl7jDBvsuZCmAVHuT.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/6YS27jl7jDBvsuZCmAVHuT.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/6YS27jl7jDBvsuZCmAVHuT.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Postcard Painting 3",
										"year": 2023,
										"medium": "oil on oil paint tablet",
										"dimensions": "10.5 x 15cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/7gpXYR6HqDPc3kkkrhSCOK.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/7gpXYR6HqDPc3kkkrhSCOK.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/7gpXYR6HqDPc3kkkrhSCOK.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/7gpXYR6HqDPc3kkkrhSCOK.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/7gpXYR6HqDPc3kkkrhSCOK.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/7gpXYR6HqDPc3kkkrhSCOK.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/7gpXYR6HqDPc3kkkrhSCOK.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/7gpXYR6HqDPc3kkkrhSCOK.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Postcard Painting 5",
										"year": 2023,
										"medium": "oil on oil paint tablet",
										"dimensions": "10.5 x 15cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/me4lJGlC3Ag80xvH229wd.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/me4lJGlC3Ag80xvH229wd.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/me4lJGlC3Ag80xvH229wd.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/me4lJGlC3Ag80xvH229wd.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/me4lJGlC3Ag80xvH229wd.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/me4lJGlC3Ag80xvH229wd.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/me4lJGlC3Ag80xvH229wd.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/me4lJGlC3Ag80xvH229wd.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Postcard Painting 7",
										"year": 2023,
										"medium": "oil on oil paint tablet",
										"dimensions": "15 x 10.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/01CTBliXIO7CZqnOGoEY9u.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/01CTBliXIO7CZqnOGoEY9u.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/01CTBliXIO7CZqnOGoEY9u.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/01CTBliXIO7CZqnOGoEY9u.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/01CTBliXIO7CZqnOGoEY9u.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/01CTBliXIO7CZqnOGoEY9u.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/01CTBliXIO7CZqnOGoEY9u.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/01CTBliXIO7CZqnOGoEY9u.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Postcard Painting 9",
										"year": 2024,
										"medium": "oil on oil paint tablet",
										"dimensions": "10.5 x 15cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/2grHPyfMEnl8vJrBydGCO9.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/2grHPyfMEnl8vJrBydGCO9.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/2grHPyfMEnl8vJrBydGCO9.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/2grHPyfMEnl8vJrBydGCO9.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/2grHPyfMEnl8vJrBydGCO9.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/2grHPyfMEnl8vJrBydGCO9.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/2grHPyfMEnl8vJrBydGCO9.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/2grHPyfMEnl8vJrBydGCO9.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Postcard Painting 8",
										"year": 2024,
										"medium": "oil on oil paint tablet",
										"dimensions": "10.5 x 15cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/70nAlgEAgHGtvOc1upqy4F.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/70nAlgEAgHGtvOc1upqy4F.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/70nAlgEAgHGtvOc1upqy4F.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/70nAlgEAgHGtvOc1upqy4F.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/70nAlgEAgHGtvOc1upqy4F.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/70nAlgEAgHGtvOc1upqy4F.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/70nAlgEAgHGtvOc1upqy4F.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/70nAlgEAgHGtvOc1upqy4F.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Real and Not Real",
										"year": 2024,
										"medium": "oil on oil paint tablet",
										"dimensions": "16.5 x 28.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/1qhXoY4baILi0GQWqwbfiJ.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/1qhXoY4baILi0GQWqwbfiJ.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/1qhXoY4baILi0GQWqwbfiJ.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/1qhXoY4baILi0GQWqwbfiJ.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/1qhXoY4baILi0GQWqwbfiJ.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/1qhXoY4baILi0GQWqwbfiJ.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/1qhXoY4baILi0GQWqwbfiJ.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/1qhXoY4baILi0GQWqwbfiJ.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Without You Again",
										"year": 2024,
										"medium": "oil on oil paint tablet",
										"dimensions": "30.5 x 44.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/5wknLhiaiwVpcgvUqxUqme.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/5wknLhiaiwVpcgvUqxUqme.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/5wknLhiaiwVpcgvUqxUqme.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/5wknLhiaiwVpcgvUqxUqme.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/5wknLhiaiwVpcgvUqxUqme.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/5wknLhiaiwVpcgvUqxUqme.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/5wknLhiaiwVpcgvUqxUqme.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/5wknLhiaiwVpcgvUqxUqme.jpg",
																"width": 1366
														}
												]
										}
								}
						],
						"archive": false
				},
				{
						"linkName": "re-plays",
						"name": "Re-plays",
						"type": "Painting",
						"copy": "<h2>RE-PLAYS</h2>\n<p><i>Reasoning means walking in a straight line, while the body instinctively walks in circles</i></p>\n<p>Luis Sagasti</p>\n<p>These works are based on unseen studio performances. I re-enact found archival photographs to accent the physical relationships between subjects. Time-lapse image capture allows me to adopt each pose in turn before montaging these individual stills into complete figure groupings. Without the details of their original history or place, these pictures site the gesture of each body in the present and yet allow residual echoes of its previous context to be felt. Responding to this temporal displacement I work on oil paint tablets without any fixed support until each painting is resolved. This \u2018body of paint\u2019 remains in flux until completely dry and there is always the threat of surface abrasions, creases, troughs and pock marks subsuming each representation. I enjoy this tension between the physical presence of the paint object and its image, and that both are made of the same matter.</p>",
						"archive": true,
						"coverImage": {
								"fallbackImageUrl": "https://images.tonyhull.com/1024/attu6XzI84cQNRjIa.jpg",
								"imageSizes": [
										{
												"url": "https://images.tonyhull.com/320/attu6XzI84cQNRjIa.jpg",
												"width": 320
										},
										{
												"url": "https://images.tonyhull.com/768/attu6XzI84cQNRjIa.jpg",
												"width": 768
										},
										{
												"url": "https://images.tonyhull.com/640/attu6XzI84cQNRjIa.jpg",
												"width": 640
										},
										{
												"url": "https://images.tonyhull.com/1024/attu6XzI84cQNRjIa.jpg",
												"width": 1024
										},
										{
												"url": "https://images.tonyhull.com/1600/attu6XzI84cQNRjIa.jpg",
												"width": 1600
										},
										{
												"url": "https://images.tonyhull.com/1920/attu6XzI84cQNRjIa.jpg",
												"width": 1920
										},
										{
												"url": "https://images.tonyhull.com/1366/attu6XzI84cQNRjIa.jpg",
												"width": 1366
										}
								]
						},
						"pieces": [
								{
										"title": "Smart People",
										"year": 2020,
										"medium": "oil on oil paint tablet",
										"dimensions": "13 x 22cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attQ9DyV0Ubocqrir.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attQ9DyV0Ubocqrir.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attQ9DyV0Ubocqrir.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attQ9DyV0Ubocqrir.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attQ9DyV0Ubocqrir.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attQ9DyV0Ubocqrir.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attQ9DyV0Ubocqrir.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attQ9DyV0Ubocqrir.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "In-between",
										"year": 2020,
										"medium": "oil on oil paint tablet",
										"dimensions": "13.5 x 22.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attg8ph2yeRM3JeoV.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attg8ph2yeRM3JeoV.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attg8ph2yeRM3JeoV.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attg8ph2yeRM3JeoV.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attg8ph2yeRM3JeoV.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attg8ph2yeRM3JeoV.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attg8ph2yeRM3JeoV.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attg8ph2yeRM3JeoV.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "False Assurances",
										"year": 2020,
										"medium": "oil on oil paint tablet",
										"dimensions": "13.5 x 20.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attxJtlpaKS1vgYoE.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attxJtlpaKS1vgYoE.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attxJtlpaKS1vgYoE.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attxJtlpaKS1vgYoE.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attxJtlpaKS1vgYoE.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attxJtlpaKS1vgYoE.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attxJtlpaKS1vgYoE.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attxJtlpaKS1vgYoE.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "All Fall Down",
										"year": 2019,
										"medium": "oil on oil paint tablet",
										"dimensions": "10.5 x 22cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attlv4RhmgaFcU93v.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attlv4RhmgaFcU93v.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attlv4RhmgaFcU93v.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attlv4RhmgaFcU93v.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attlv4RhmgaFcU93v.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attlv4RhmgaFcU93v.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attlv4RhmgaFcU93v.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attlv4RhmgaFcU93v.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Loss and Intimacy",
										"year": 2019,
										"medium": "oil on oil paint tablet",
										"dimensions": "24 x 33cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/cwuC4LnVz7lhdxttAy2Mi.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/cwuC4LnVz7lhdxttAy2Mi.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/cwuC4LnVz7lhdxttAy2Mi.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/cwuC4LnVz7lhdxttAy2Mi.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/cwuC4LnVz7lhdxttAy2Mi.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/cwuC4LnVz7lhdxttAy2Mi.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/cwuC4LnVz7lhdxttAy2Mi.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/cwuC4LnVz7lhdxttAy2Mi.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Consequences Intended",
										"year": 2020,
										"medium": "oil on oil paint tablet",
										"dimensions": "13.5 x 13cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/att9w7bN03FWlmCWg.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/att9w7bN03FWlmCWg.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/att9w7bN03FWlmCWg.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/att9w7bN03FWlmCWg.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/att9w7bN03FWlmCWg.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/att9w7bN03FWlmCWg.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/att9w7bN03FWlmCWg.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/att9w7bN03FWlmCWg.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Habits of Repetition",
										"year": 2020,
										"medium": "oil on oil paint tablet",
										"dimensions": "36 x 23cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attcdULB5hNn2WfLU.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attcdULB5hNn2WfLU.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attcdULB5hNn2WfLU.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attcdULB5hNn2WfLU.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attcdULB5hNn2WfLU.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attcdULB5hNn2WfLU.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attcdULB5hNn2WfLU.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attcdULB5hNn2WfLU.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Temporary Futures",
										"year": 2019,
										"medium": "oil on oil paint tablet",
										"dimensions": "14 x 22cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attLVQ38ga4Jc3uKl.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attLVQ38ga4Jc3uKl.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attLVQ38ga4Jc3uKl.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attLVQ38ga4Jc3uKl.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attLVQ38ga4Jc3uKl.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attLVQ38ga4Jc3uKl.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attLVQ38ga4Jc3uKl.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attLVQ38ga4Jc3uKl.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Plumb Line",
										"year": 2019,
										"medium": "oil on oil paint tablet",
										"dimensions": "14 x 19.5",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attdoZG1c40BaGnOB.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attdoZG1c40BaGnOB.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attdoZG1c40BaGnOB.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attdoZG1c40BaGnOB.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attdoZG1c40BaGnOB.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attdoZG1c40BaGnOB.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attdoZG1c40BaGnOB.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attdoZG1c40BaGnOB.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Hidden Strategies",
										"year": 2019,
										"medium": "oil on oil paint tablet",
										"dimensions": "22 x 14cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attmD15QDQxhQAenV.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attmD15QDQxhQAenV.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attmD15QDQxhQAenV.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attmD15QDQxhQAenV.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attmD15QDQxhQAenV.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attmD15QDQxhQAenV.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attmD15QDQxhQAenV.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attmD15QDQxhQAenV.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Reaching",
										"year": 2020,
										"medium": "oil on oil paint tablet",
										"dimensions": "23.5 x 33cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/att8fF8Ihwpp57sZT.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/att8fF8Ihwpp57sZT.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/att8fF8Ihwpp57sZT.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/att8fF8Ihwpp57sZT.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/att8fF8Ihwpp57sZT.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/att8fF8Ihwpp57sZT.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/att8fF8Ihwpp57sZT.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/att8fF8Ihwpp57sZT.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Consequences",
										"year": 2020,
										"medium": "oil on oil paint tablet",
										"dimensions": "13.5 x 21cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attaGl1qeggkE90jw.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attaGl1qeggkE90jw.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attaGl1qeggkE90jw.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attaGl1qeggkE90jw.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attaGl1qeggkE90jw.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attaGl1qeggkE90jw.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attaGl1qeggkE90jw.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attaGl1qeggkE90jw.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Group Manoeuvres",
										"year": 2020,
										"medium": "oil on oil paint tablet",
										"dimensions": "13.5 x 21cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attxLcM1rlfcw61Gp.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attxLcM1rlfcw61Gp.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attxLcM1rlfcw61Gp.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attxLcM1rlfcw61Gp.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attxLcM1rlfcw61Gp.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attxLcM1rlfcw61Gp.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attxLcM1rlfcw61Gp.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attxLcM1rlfcw61Gp.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Truths and Untruths",
										"year": 2020,
										"medium": "oil on oil paint tablet",
										"dimensions": "15.5 x 28.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attxRcZ7AJ9GWjBl0.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attxRcZ7AJ9GWjBl0.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attxRcZ7AJ9GWjBl0.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attxRcZ7AJ9GWjBl0.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attxRcZ7AJ9GWjBl0.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attxRcZ7AJ9GWjBl0.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attxRcZ7AJ9GWjBl0.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attxRcZ7AJ9GWjBl0.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Back to Task",
										"year": 2020,
										"medium": "oil on oil paint ablet",
										"dimensions": "14 x 22",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attbLLVyOwzCMG82E.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attbLLVyOwzCMG82E.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attbLLVyOwzCMG82E.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attbLLVyOwzCMG82E.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attbLLVyOwzCMG82E.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attbLLVyOwzCMG82E.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attbLLVyOwzCMG82E.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attbLLVyOwzCMG82E.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Etiquette Extended",
										"year": 2020,
										"medium": "oil on oil paint tablet",
										"dimensions": "25 x 40cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attxSXoTw3VYl5tFB.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attxSXoTw3VYl5tFB.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attxSXoTw3VYl5tFB.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attxSXoTw3VYl5tFB.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attxSXoTw3VYl5tFB.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attxSXoTw3VYl5tFB.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attxSXoTw3VYl5tFB.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attxSXoTw3VYl5tFB.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Indeterminate State",
										"year": 2020,
										"medium": "oil on oil paint tablet",
										"dimensions": "23 x 40cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attvu7Yhqldose1dk.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attvu7Yhqldose1dk.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attvu7Yhqldose1dk.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attvu7Yhqldose1dk.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attvu7Yhqldose1dk.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attvu7Yhqldose1dk.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attvu7Yhqldose1dk.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attvu7Yhqldose1dk.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "History has a Habit",
										"year": 2020,
										"medium": "oil on oil paint tablet",
										"dimensions": "22.5 x 39.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attJzHj89DGnKezoY.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attJzHj89DGnKezoY.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attJzHj89DGnKezoY.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attJzHj89DGnKezoY.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attJzHj89DGnKezoY.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attJzHj89DGnKezoY.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attJzHj89DGnKezoY.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attJzHj89DGnKezoY.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Legitimate Grounds",
										"year": 2020,
										"medium": "oil on oil paint tablet",
										"dimensions": "31 x 44cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attaQ15CWOxV7bTEL.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attaQ15CWOxV7bTEL.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attaQ15CWOxV7bTEL.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attaQ15CWOxV7bTEL.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attaQ15CWOxV7bTEL.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attaQ15CWOxV7bTEL.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attaQ15CWOxV7bTEL.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attaQ15CWOxV7bTEL.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Make a Wish",
										"year": 2020,
										"medium": "oil on oil paint tablet",
										"dimensions": "31 x 44cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attf2MYG3r66bVJVN.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attf2MYG3r66bVJVN.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attf2MYG3r66bVJVN.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attf2MYG3r66bVJVN.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attf2MYG3r66bVJVN.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attf2MYG3r66bVJVN.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attf2MYG3r66bVJVN.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attf2MYG3r66bVJVN.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Stand",
										"year": 2020,
										"medium": "oil on oil paint tablet",
										"dimensions": "14 x 22cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/att6ac2AaqTaYycTF.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/att6ac2AaqTaYycTF.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/att6ac2AaqTaYycTF.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/att6ac2AaqTaYycTF.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/att6ac2AaqTaYycTF.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/att6ac2AaqTaYycTF.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/att6ac2AaqTaYycTF.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/att6ac2AaqTaYycTF.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Ritual Without Myth",
										"year": 2019,
										"medium": "oil on oil paint tablet",
										"dimensions": "14 x 22cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/atttpwcgvrejXTOer.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/atttpwcgvrejXTOer.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/atttpwcgvrejXTOer.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/atttpwcgvrejXTOer.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/atttpwcgvrejXTOer.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/atttpwcgvrejXTOer.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/atttpwcgvrejXTOer.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/atttpwcgvrejXTOer.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Happy Times",
										"year": 2019,
										"medium": "oil on oil paint tablet",
										"dimensions": "14 x 22cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/6pMf1HyxWToAW4DfJKsGvC.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/6pMf1HyxWToAW4DfJKsGvC.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/6pMf1HyxWToAW4DfJKsGvC.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/6pMf1HyxWToAW4DfJKsGvC.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/6pMf1HyxWToAW4DfJKsGvC.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/6pMf1HyxWToAW4DfJKsGvC.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/6pMf1HyxWToAW4DfJKsGvC.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/6pMf1HyxWToAW4DfJKsGvC.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Shadow of Doubt",
										"year": 2020,
										"medium": "oil on oil paint tablet",
										"dimensions": "13.5 x 22cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/atttr8KEMO2f6ZEIO.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/atttr8KEMO2f6ZEIO.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/atttr8KEMO2f6ZEIO.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/atttr8KEMO2f6ZEIO.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/atttr8KEMO2f6ZEIO.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/atttr8KEMO2f6ZEIO.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/atttr8KEMO2f6ZEIO.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/atttr8KEMO2f6ZEIO.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Three",
										"year": 2020,
										"medium": "oil on oil paint tablet",
										"dimensions": "28 x 16cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attPPVnqi0KcFWbVl.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attPPVnqi0KcFWbVl.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attPPVnqi0KcFWbVl.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attPPVnqi0KcFWbVl.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attPPVnqi0KcFWbVl.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attPPVnqi0KcFWbVl.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attPPVnqi0KcFWbVl.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attPPVnqi0KcFWbVl.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "True and Not true",
										"year": 2020,
										"medium": "oil on oil paint tablet",
										"dimensions": "22 x 22cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/atteiglnhGjB1fyYV.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/atteiglnhGjB1fyYV.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/atteiglnhGjB1fyYV.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/atteiglnhGjB1fyYV.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/atteiglnhGjB1fyYV.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/atteiglnhGjB1fyYV.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/atteiglnhGjB1fyYV.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/atteiglnhGjB1fyYV.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "True and Not",
										"year": 2020,
										"medium": "oil on oil paint tablet",
										"dimensions": "16 x 27.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attpwlm05Q7tOkYa7.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attpwlm05Q7tOkYa7.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attpwlm05Q7tOkYa7.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attpwlm05Q7tOkYa7.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attpwlm05Q7tOkYa7.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attpwlm05Q7tOkYa7.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attpwlm05Q7tOkYa7.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attpwlm05Q7tOkYa7.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Stages of Competency",
										"year": 2020,
										"medium": "oil on oil paint tablet",
										"dimensions": "23 x 34cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attXbLqYnFu4YLMt3.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attXbLqYnFu4YLMt3.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attXbLqYnFu4YLMt3.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attXbLqYnFu4YLMt3.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attXbLqYnFu4YLMt3.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attXbLqYnFu4YLMt3.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attXbLqYnFu4YLMt3.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attXbLqYnFu4YLMt3.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "What I Don't Know",
										"year": 2019,
										"medium": "oil on oil paint tablet",
										"dimensions": "16 x 26cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/att01F0nv72W5Ng9g.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/att01F0nv72W5Ng9g.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/att01F0nv72W5Ng9g.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/att01F0nv72W5Ng9g.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/att01F0nv72W5Ng9g.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/att01F0nv72W5Ng9g.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/att01F0nv72W5Ng9g.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/att01F0nv72W5Ng9g.jpg",
																"width": 1366
														}
												]
										}
								}
						],
						"current": false
				},
				{
						"linkName": "unintended-consequences",
						"name": "Unintended Consequences",
						"type": "Drawing",
						"copy": "<h2>UNINTENDED CONSEQUENCES</h2>\n<p>My method involves a lot of drawing. It allows me to pause in a moment I might ordinarily move through, slowing down the rate at which I absorb images and tempering the rush to judgement. Photography informs these works strongly. The relationship between the single instant of digital image capture and the \u2018slow\u2019 images created by drawing intrigues me. Working in series, I migrate between individual sketches to edit my material. It\u2019s quite a labour-intensive process where the evidence of my body\u2019s movement becomes embedded in each surface.</p>",
						"archive": true,
						"coverImage": {
								"fallbackImageUrl": "https://images.tonyhull.com/1024/att6u64P36B0wqdwN.jpg",
								"imageSizes": [
										{
												"url": "https://images.tonyhull.com/320/att6u64P36B0wqdwN.jpg",
												"width": 320
										},
										{
												"url": "https://images.tonyhull.com/768/att6u64P36B0wqdwN.jpg",
												"width": 768
										},
										{
												"url": "https://images.tonyhull.com/640/att6u64P36B0wqdwN.jpg",
												"width": 640
										},
										{
												"url": "https://images.tonyhull.com/1024/att6u64P36B0wqdwN.jpg",
												"width": 1024
										},
										{
												"url": "https://images.tonyhull.com/1600/att6u64P36B0wqdwN.jpg",
												"width": 1600
										},
										{
												"url": "https://images.tonyhull.com/1920/att6u64P36B0wqdwN.jpg",
												"width": 1920
										},
										{
												"url": "https://images.tonyhull.com/1366/att6u64P36B0wqdwN.jpg",
												"width": 1366
										}
								]
						},
						"pieces": [
								{
										"title": "A Different Truth",
										"year": 2020,
										"medium": "graphite on Fabriano",
										"dimensions": "23 x 39.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attvqJ3sRqUnSOHo0.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attvqJ3sRqUnSOHo0.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attvqJ3sRqUnSOHo0.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attvqJ3sRqUnSOHo0.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attvqJ3sRqUnSOHo0.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attvqJ3sRqUnSOHo0.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attvqJ3sRqUnSOHo0.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attvqJ3sRqUnSOHo0.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "And Then",
										"year": 2020,
										"medium": "graphite on Fabriano",
										"dimensions": "23 x 39.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attmf6kIZVYjctC0v.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attmf6kIZVYjctC0v.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attmf6kIZVYjctC0v.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attmf6kIZVYjctC0v.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attmf6kIZVYjctC0v.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attmf6kIZVYjctC0v.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attmf6kIZVYjctC0v.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attmf6kIZVYjctC0v.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Echo Chamber",
										"year": 2020,
										"medium": "graphite on Fabriano",
										"dimensions": "23 x 39.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/atthdgN8SFR2cLNPP.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/atthdgN8SFR2cLNPP.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/atthdgN8SFR2cLNPP.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/atthdgN8SFR2cLNPP.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/atthdgN8SFR2cLNPP.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/atthdgN8SFR2cLNPP.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/atthdgN8SFR2cLNPP.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/atthdgN8SFR2cLNPP.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Etiquette",
										"year": 2020,
										"medium": "graphite on Fabriano",
										"dimensions": "23 x 39.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attJWrv1BtZkUFLXh.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attJWrv1BtZkUFLXh.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attJWrv1BtZkUFLXh.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attJWrv1BtZkUFLXh.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attJWrv1BtZkUFLXh.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attJWrv1BtZkUFLXh.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attJWrv1BtZkUFLXh.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attJWrv1BtZkUFLXh.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Hidden",
										"year": 2020,
										"medium": "graphite on Fabriano",
										"dimensions": "23 x 39.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attiShWg3buZCNCUZ.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attiShWg3buZCNCUZ.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attiShWg3buZCNCUZ.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attiShWg3buZCNCUZ.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attiShWg3buZCNCUZ.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attiShWg3buZCNCUZ.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attiShWg3buZCNCUZ.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attiShWg3buZCNCUZ.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "History has a Habit",
										"year": 2020,
										"medium": "graphite on Fabriano",
										"dimensions": "23 x 39.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attUmajUV2QwSU614.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attUmajUV2QwSU614.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attUmajUV2QwSU614.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attUmajUV2QwSU614.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attUmajUV2QwSU614.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attUmajUV2QwSU614.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attUmajUV2QwSU614.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attUmajUV2QwSU614.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Legitimate Grounds",
										"year": 2020,
										"medium": "graphite on Fabriano",
										"dimensions": "23 x 39.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attKVPmfdXO9VoC4M.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attKVPmfdXO9VoC4M.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attKVPmfdXO9VoC4M.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attKVPmfdXO9VoC4M.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attKVPmfdXO9VoC4M.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attKVPmfdXO9VoC4M.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attKVPmfdXO9VoC4M.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attKVPmfdXO9VoC4M.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Mirror",
										"year": 2020,
										"medium": "graphite on Fabriano",
										"dimensions": "23 x 39.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attRGydtMch3C66i4.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attRGydtMch3C66i4.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attRGydtMch3C66i4.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attRGydtMch3C66i4.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attRGydtMch3C66i4.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attRGydtMch3C66i4.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attRGydtMch3C66i4.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attRGydtMch3C66i4.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Process of Elimination",
										"year": 2020,
										"medium": "graphite on Fabriano",
										"dimensions": "23 x 39.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attxp0C8MqHvwzRcu.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attxp0C8MqHvwzRcu.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attxp0C8MqHvwzRcu.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attxp0C8MqHvwzRcu.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attxp0C8MqHvwzRcu.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attxp0C8MqHvwzRcu.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attxp0C8MqHvwzRcu.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attxp0C8MqHvwzRcu.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Reaching",
										"year": 2020,
										"medium": "graphite on Fabriano",
										"dimensions": "23 x 39.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attWO5xDWNO7R4qjn.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attWO5xDWNO7R4qjn.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attWO5xDWNO7R4qjn.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attWO5xDWNO7R4qjn.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attWO5xDWNO7R4qjn.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attWO5xDWNO7R4qjn.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attWO5xDWNO7R4qjn.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attWO5xDWNO7R4qjn.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Smart People",
										"year": 2020,
										"medium": "graphite on Fabriano",
										"dimensions": "23 x 39.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attPGQVaHbHYdLgGa.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attPGQVaHbHYdLgGa.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attPGQVaHbHYdLgGa.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attPGQVaHbHYdLgGa.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attPGQVaHbHYdLgGa.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attPGQVaHbHYdLgGa.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attPGQVaHbHYdLgGa.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attPGQVaHbHYdLgGa.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Smoke and Mirrors",
										"year": 2020,
										"medium": "graphite on Fabriano",
										"dimensions": "39.5 x 23cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attMCvKtPt3amIqB0.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attMCvKtPt3amIqB0.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attMCvKtPt3amIqB0.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attMCvKtPt3amIqB0.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attMCvKtPt3amIqB0.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attMCvKtPt3amIqB0.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attMCvKtPt3amIqB0.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attMCvKtPt3amIqB0.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Stages of Competence",
										"year": 2019,
										"medium": "graphite on Fabriano",
										"dimensions": "23 x 39.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attwKyUcPOqNZBzR7.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attwKyUcPOqNZBzR7.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attwKyUcPOqNZBzR7.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attwKyUcPOqNZBzR7.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attwKyUcPOqNZBzR7.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attwKyUcPOqNZBzR7.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attwKyUcPOqNZBzR7.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attwKyUcPOqNZBzR7.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Three",
										"year": 2020,
										"medium": "graphite on Fabriano",
										"dimensions": "39.5 x 23cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attKZ0M30aFhCjzOO.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attKZ0M30aFhCjzOO.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attKZ0M30aFhCjzOO.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attKZ0M30aFhCjzOO.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attKZ0M30aFhCjzOO.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attKZ0M30aFhCjzOO.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attKZ0M30aFhCjzOO.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attKZ0M30aFhCjzOO.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Time and Space",
										"year": 2020,
										"medium": "graphite on Fabriano",
										"dimensions": "39.5 x 23cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attFFS9PbWCXbxPK5.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attFFS9PbWCXbxPK5.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attFFS9PbWCXbxPK5.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attFFS9PbWCXbxPK5.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attFFS9PbWCXbxPK5.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attFFS9PbWCXbxPK5.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attFFS9PbWCXbxPK5.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attFFS9PbWCXbxPK5.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "True and Not True",
										"year": 2020,
										"medium": "graphite on Fabriano",
										"dimensions": "20 x 39cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/att1fT8mxb3uDqH2F.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/att1fT8mxb3uDqH2F.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/att1fT8mxb3uDqH2F.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/att1fT8mxb3uDqH2F.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/att1fT8mxb3uDqH2F.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/att1fT8mxb3uDqH2F.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/att1fT8mxb3uDqH2F.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/att1fT8mxb3uDqH2F.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Truth and its Opposite",
										"year": 2020,
										"medium": "graphite on Fabriano",
										"dimensions": "39.5 x 23cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attKDEPp1EhvrLLsL.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attKDEPp1EhvrLLsL.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attKDEPp1EhvrLLsL.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attKDEPp1EhvrLLsL.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attKDEPp1EhvrLLsL.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attKDEPp1EhvrLLsL.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attKDEPp1EhvrLLsL.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attKDEPp1EhvrLLsL.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "What I don't Know",
										"year": 2019,
										"medium": "graphite on Fabriano",
										"dimensions": "23 x 39.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attxWmguQ8PPFjcJb.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attxWmguQ8PPFjcJb.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attxWmguQ8PPFjcJb.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attxWmguQ8PPFjcJb.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attxWmguQ8PPFjcJb.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attxWmguQ8PPFjcJb.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attxWmguQ8PPFjcJb.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attxWmguQ8PPFjcJb.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Unnamed Sources",
										"year": 2020,
										"medium": "graphite on Fabriano",
										"dimensions": "23 x 39.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attJyDe9nzEu7IpqQ.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attJyDe9nzEu7IpqQ.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attJyDe9nzEu7IpqQ.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attJyDe9nzEu7IpqQ.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attJyDe9nzEu7IpqQ.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attJyDe9nzEu7IpqQ.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attJyDe9nzEu7IpqQ.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attJyDe9nzEu7IpqQ.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Habit of Repetition",
										"year": 2020,
										"medium": "graphite on Fabriano",
										"dimensions": "39.5 x 23cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attrUAtQh29thdF9T.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attrUAtQh29thdF9T.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attrUAtQh29thdF9T.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attrUAtQh29thdF9T.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attrUAtQh29thdF9T.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attrUAtQh29thdF9T.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attrUAtQh29thdF9T.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attrUAtQh29thdF9T.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Shadow of Doubt",
										"year": 2020,
										"medium": "graphite on Fabriano",
										"dimensions": "20 x 39cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attsTcCKYYSlaMhFv.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attsTcCKYYSlaMhFv.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attsTcCKYYSlaMhFv.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attsTcCKYYSlaMhFv.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attsTcCKYYSlaMhFv.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attsTcCKYYSlaMhFv.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attsTcCKYYSlaMhFv.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attsTcCKYYSlaMhFv.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Balancing Act",
										"year": 2020,
										"medium": "graphite on Fabriano",
										"dimensions": "23 x 39.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attzMTyqbQsAcVMEA.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attzMTyqbQsAcVMEA.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attzMTyqbQsAcVMEA.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attzMTyqbQsAcVMEA.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attzMTyqbQsAcVMEA.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attzMTyqbQsAcVMEA.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attzMTyqbQsAcVMEA.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attzMTyqbQsAcVMEA.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Truths and Untruths",
										"year": 2020,
										"medium": "graphite on Fabriano",
										"dimensions": "23 x 39.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attiDyRJ3pqsrhM3i.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attiDyRJ3pqsrhM3i.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attiDyRJ3pqsrhM3i.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attiDyRJ3pqsrhM3i.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attiDyRJ3pqsrhM3i.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attiDyRJ3pqsrhM3i.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attiDyRJ3pqsrhM3i.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attiDyRJ3pqsrhM3i.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Make a Wish",
										"year": 2020,
										"medium": "graphite on Fabriano",
										"dimensions": "23 x 39.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attwViWAZfW58Gy4O.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attwViWAZfW58Gy4O.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attwViWAZfW58Gy4O.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attwViWAZfW58Gy4O.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attwViWAZfW58Gy4O.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attwViWAZfW58Gy4O.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attwViWAZfW58Gy4O.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attwViWAZfW58Gy4O.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "True and Not",
										"year": 2020,
										"medium": "graphite on Fabriano",
										"dimensions": "23 x 39.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attPnHKAsBFAPibXD.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attPnHKAsBFAPibXD.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attPnHKAsBFAPibXD.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attPnHKAsBFAPibXD.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attPnHKAsBFAPibXD.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attPnHKAsBFAPibXD.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attPnHKAsBFAPibXD.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attPnHKAsBFAPibXD.jpg",
																"width": 1366
														}
												]
										}
								}
						],
						"current": false
				},
				{
						"linkName": "meat-puppets",
						"name": "Meat Puppets",
						"type": "Drawing",
						"copy": "<h2>MEAT PUPPETS</h2>\n<p><b>\u25b8 </b><b><i>noun</i></b><b>:</b> A human body without consciousness. <b>\u25b8 </b><b><i>noun</i></b><b>:</b> A body that is controlled by someone or something else.</p>\n<p>As performance has become an increasing part of my working process, I\u2019ve grown more aware of my body and notice actions and mannerisms in other bodies I wouldn\u2019t have previously. These I register in my own physical self, imagining how it might be execute them so that I can subsequently re-enact and film what I\u2019ve seen in the studio. I now have an archive of these gestures from which this series of drawings emerged. I first started experimenting with emulsion paint when I ran out of white ink. Its absorbent properties and unpredictable interaction with Indian ink affects the \u2018non space\u2019 my figures inhabit making it feel substantially more present.</p>",
						"archive": true,
						"coverImage": {
								"fallbackImageUrl": "https://images.tonyhull.com/1024/attP11h8WVLfpwwcu.jpg",
								"imageSizes": [
										{
												"url": "https://images.tonyhull.com/320/attP11h8WVLfpwwcu.jpg",
												"width": 320
										},
										{
												"url": "https://images.tonyhull.com/768/attP11h8WVLfpwwcu.jpg",
												"width": 768
										},
										{
												"url": "https://images.tonyhull.com/640/attP11h8WVLfpwwcu.jpg",
												"width": 640
										},
										{
												"url": "https://images.tonyhull.com/1024/attP11h8WVLfpwwcu.jpg",
												"width": 1024
										},
										{
												"url": "https://images.tonyhull.com/1600/attP11h8WVLfpwwcu.jpg",
												"width": 1600
										},
										{
												"url": "https://images.tonyhull.com/1920/attP11h8WVLfpwwcu.jpg",
												"width": 1920
										},
										{
												"url": "https://images.tonyhull.com/1366/attP11h8WVLfpwwcu.jpg",
												"width": 1366
										}
								]
						},
						"pieces": [
								{
										"title": "Consequences",
										"year": 2022,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "25 x 18cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/3ZRXUJqwkGxHnZsBvWEm51.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/3ZRXUJqwkGxHnZsBvWEm51.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/3ZRXUJqwkGxHnZsBvWEm51.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/3ZRXUJqwkGxHnZsBvWEm51.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/3ZRXUJqwkGxHnZsBvWEm51.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/3ZRXUJqwkGxHnZsBvWEm51.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/3ZRXUJqwkGxHnZsBvWEm51.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/3ZRXUJqwkGxHnZsBvWEm51.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Estranged",
										"year": 2022,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "25 x 18cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/43XxeWoXcUjVktV2MFRA8L.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/43XxeWoXcUjVktV2MFRA8L.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/43XxeWoXcUjVktV2MFRA8L.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/43XxeWoXcUjVktV2MFRA8L.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/43XxeWoXcUjVktV2MFRA8L.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/43XxeWoXcUjVktV2MFRA8L.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/43XxeWoXcUjVktV2MFRA8L.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/43XxeWoXcUjVktV2MFRA8L.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Starting Place",
										"year": 2022,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "25 x 18cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/6xisswRdPRKCLxARSzYyci.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/6xisswRdPRKCLxARSzYyci.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/6xisswRdPRKCLxARSzYyci.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/6xisswRdPRKCLxARSzYyci.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/6xisswRdPRKCLxARSzYyci.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/6xisswRdPRKCLxARSzYyci.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/6xisswRdPRKCLxARSzYyci.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/6xisswRdPRKCLxARSzYyci.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Joy and Its Opposite",
										"year": 2022,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "25 x 35.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/6iW2dpRHQsuLmcdGdZlx7P.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/6iW2dpRHQsuLmcdGdZlx7P.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/6iW2dpRHQsuLmcdGdZlx7P.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/6iW2dpRHQsuLmcdGdZlx7P.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/6iW2dpRHQsuLmcdGdZlx7P.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/6iW2dpRHQsuLmcdGdZlx7P.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/6iW2dpRHQsuLmcdGdZlx7P.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/6iW2dpRHQsuLmcdGdZlx7P.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Not Yet True",
										"year": 2022,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "25 x 18cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/20or5VPeGANdnydD1yYc4F.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/20or5VPeGANdnydD1yYc4F.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/20or5VPeGANdnydD1yYc4F.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/20or5VPeGANdnydD1yYc4F.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/20or5VPeGANdnydD1yYc4F.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/20or5VPeGANdnydD1yYc4F.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/20or5VPeGANdnydD1yYc4F.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/20or5VPeGANdnydD1yYc4F.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Sixes and Sevens",
										"year": 2022,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "25 x 18cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/3uqlFkrk3MuDStOKfAlh18.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/3uqlFkrk3MuDStOKfAlh18.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/3uqlFkrk3MuDStOKfAlh18.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/3uqlFkrk3MuDStOKfAlh18.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/3uqlFkrk3MuDStOKfAlh18.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/3uqlFkrk3MuDStOKfAlh18.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/3uqlFkrk3MuDStOKfAlh18.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/3uqlFkrk3MuDStOKfAlh18.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Dancing and Not",
										"year": 2022,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "18 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/2AU4nMM7UU7mrH7cG7T7oa.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/2AU4nMM7UU7mrH7cG7T7oa.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/2AU4nMM7UU7mrH7cG7T7oa.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/2AU4nMM7UU7mrH7cG7T7oa.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/2AU4nMM7UU7mrH7cG7T7oa.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/2AU4nMM7UU7mrH7cG7T7oa.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/2AU4nMM7UU7mrH7cG7T7oa.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/2AU4nMM7UU7mrH7cG7T7oa.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Me, Myself and I",
										"year": 2022,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "18 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/1W0IdERPYQNVRxu1My9Pry.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/1W0IdERPYQNVRxu1My9Pry.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/1W0IdERPYQNVRxu1My9Pry.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/1W0IdERPYQNVRxu1My9Pry.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/1W0IdERPYQNVRxu1My9Pry.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/1W0IdERPYQNVRxu1My9Pry.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/1W0IdERPYQNVRxu1My9Pry.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/1W0IdERPYQNVRxu1My9Pry.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Blind Choice",
										"year": 2022,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "25 x 18cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/1D4ICXkaOfEh9UGsTOU8Q0.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/1D4ICXkaOfEh9UGsTOU8Q0.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/1D4ICXkaOfEh9UGsTOU8Q0.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/1D4ICXkaOfEh9UGsTOU8Q0.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/1D4ICXkaOfEh9UGsTOU8Q0.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/1D4ICXkaOfEh9UGsTOU8Q0.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/1D4ICXkaOfEh9UGsTOU8Q0.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/1D4ICXkaOfEh9UGsTOU8Q0.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Stray",
										"year": 2021,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "25 x 18cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/3gsSj5a6TwiQ9ie24lvzqu.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/3gsSj5a6TwiQ9ie24lvzqu.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/3gsSj5a6TwiQ9ie24lvzqu.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/3gsSj5a6TwiQ9ie24lvzqu.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/3gsSj5a6TwiQ9ie24lvzqu.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/3gsSj5a6TwiQ9ie24lvzqu.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/3gsSj5a6TwiQ9ie24lvzqu.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/3gsSj5a6TwiQ9ie24lvzqu.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Absolve",
										"year": 2021,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "35.5 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/7rh7rZ2EcLHtcX45zbensT.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/7rh7rZ2EcLHtcX45zbensT.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/7rh7rZ2EcLHtcX45zbensT.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/7rh7rZ2EcLHtcX45zbensT.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/7rh7rZ2EcLHtcX45zbensT.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/7rh7rZ2EcLHtcX45zbensT.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/7rh7rZ2EcLHtcX45zbensT.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/7rh7rZ2EcLHtcX45zbensT.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Pause",
										"year": 2021,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "18 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/6uTQaFKRRs26TN99VtgqPj.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/6uTQaFKRRs26TN99VtgqPj.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/6uTQaFKRRs26TN99VtgqPj.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/6uTQaFKRRs26TN99VtgqPj.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/6uTQaFKRRs26TN99VtgqPj.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/6uTQaFKRRs26TN99VtgqPj.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/6uTQaFKRRs26TN99VtgqPj.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/6uTQaFKRRs26TN99VtgqPj.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Second Language",
										"year": 2021,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "18 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/3WjxejkNWK28iwBs6HSTuN.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/3WjxejkNWK28iwBs6HSTuN.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/3WjxejkNWK28iwBs6HSTuN.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/3WjxejkNWK28iwBs6HSTuN.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/3WjxejkNWK28iwBs6HSTuN.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/3WjxejkNWK28iwBs6HSTuN.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/3WjxejkNWK28iwBs6HSTuN.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/3WjxejkNWK28iwBs6HSTuN.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "After the Night",
										"year": 2021,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "25 x 18cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/18s98HPh5fRAK7P2pcbyjr.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/18s98HPh5fRAK7P2pcbyjr.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/18s98HPh5fRAK7P2pcbyjr.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/18s98HPh5fRAK7P2pcbyjr.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/18s98HPh5fRAK7P2pcbyjr.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/18s98HPh5fRAK7P2pcbyjr.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/18s98HPh5fRAK7P2pcbyjr.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/18s98HPh5fRAK7P2pcbyjr.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Like with Like",
										"year": 2021,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "18 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/3N3noOnMmUmfY7ule3Qmr6.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/3N3noOnMmUmfY7ule3Qmr6.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/3N3noOnMmUmfY7ule3Qmr6.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/3N3noOnMmUmfY7ule3Qmr6.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/3N3noOnMmUmfY7ule3Qmr6.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/3N3noOnMmUmfY7ule3Qmr6.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/3N3noOnMmUmfY7ule3Qmr6.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/3N3noOnMmUmfY7ule3Qmr6.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Captive Audience",
										"year": 2021,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "25 x 35.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/L0JdzB4BeWIFQlIwvq6sf.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/L0JdzB4BeWIFQlIwvq6sf.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/L0JdzB4BeWIFQlIwvq6sf.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/L0JdzB4BeWIFQlIwvq6sf.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/L0JdzB4BeWIFQlIwvq6sf.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/L0JdzB4BeWIFQlIwvq6sf.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/L0JdzB4BeWIFQlIwvq6sf.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/L0JdzB4BeWIFQlIwvq6sf.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Without You",
										"year": 2021,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "35.5 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/2jrawJbhLKuTkXh7fTAgpm.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/2jrawJbhLKuTkXh7fTAgpm.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/2jrawJbhLKuTkXh7fTAgpm.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/2jrawJbhLKuTkXh7fTAgpm.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/2jrawJbhLKuTkXh7fTAgpm.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/2jrawJbhLKuTkXh7fTAgpm.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/2jrawJbhLKuTkXh7fTAgpm.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/2jrawJbhLKuTkXh7fTAgpm.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Something Like Kindness",
										"year": 2021,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "18 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/6PLKF4UhtKPTg8ZX0TyZeC.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/6PLKF4UhtKPTg8ZX0TyZeC.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/6PLKF4UhtKPTg8ZX0TyZeC.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/6PLKF4UhtKPTg8ZX0TyZeC.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/6PLKF4UhtKPTg8ZX0TyZeC.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/6PLKF4UhtKPTg8ZX0TyZeC.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/6PLKF4UhtKPTg8ZX0TyZeC.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/6PLKF4UhtKPTg8ZX0TyZeC.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Everything Moves Too Fast",
										"year": 2021,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "18 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/4n4EsckcbuK9kN6CS2aUod.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/4n4EsckcbuK9kN6CS2aUod.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/4n4EsckcbuK9kN6CS2aUod.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/4n4EsckcbuK9kN6CS2aUod.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/4n4EsckcbuK9kN6CS2aUod.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/4n4EsckcbuK9kN6CS2aUod.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/4n4EsckcbuK9kN6CS2aUod.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/4n4EsckcbuK9kN6CS2aUod.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Lost",
										"year": 2021,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "18 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/6HBOTiCurGo4bmW07MnGkh.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/6HBOTiCurGo4bmW07MnGkh.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/6HBOTiCurGo4bmW07MnGkh.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/6HBOTiCurGo4bmW07MnGkh.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/6HBOTiCurGo4bmW07MnGkh.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/6HBOTiCurGo4bmW07MnGkh.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/6HBOTiCurGo4bmW07MnGkh.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/6HBOTiCurGo4bmW07MnGkh.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Reciprocate",
										"year": 2022,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "25 18cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/2NpeM2N9No96b2VRryeCj5.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/2NpeM2N9No96b2VRryeCj5.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/2NpeM2N9No96b2VRryeCj5.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/2NpeM2N9No96b2VRryeCj5.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/2NpeM2N9No96b2VRryeCj5.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/2NpeM2N9No96b2VRryeCj5.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/2NpeM2N9No96b2VRryeCj5.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/2NpeM2N9No96b2VRryeCj5.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Round and Round",
										"year": 2021,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "18 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/4pwwWDoCIngalKs8FV1XeE.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/4pwwWDoCIngalKs8FV1XeE.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/4pwwWDoCIngalKs8FV1XeE.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/4pwwWDoCIngalKs8FV1XeE.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/4pwwWDoCIngalKs8FV1XeE.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/4pwwWDoCIngalKs8FV1XeE.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/4pwwWDoCIngalKs8FV1XeE.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/4pwwWDoCIngalKs8FV1XeE.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Daddy Long legs",
										"year": 2021,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "18 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/5jFmO3RFCWyYKRL62yWFua.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/5jFmO3RFCWyYKRL62yWFua.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/5jFmO3RFCWyYKRL62yWFua.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/5jFmO3RFCWyYKRL62yWFua.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/5jFmO3RFCWyYKRL62yWFua.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/5jFmO3RFCWyYKRL62yWFua.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/5jFmO3RFCWyYKRL62yWFua.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/5jFmO3RFCWyYKRL62yWFua.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Rude Awakening",
										"year": 2021,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "20.5 x 15cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/5PsnDtCnL58Q9L4WVgbgIk.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/5PsnDtCnL58Q9L4WVgbgIk.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/5PsnDtCnL58Q9L4WVgbgIk.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/5PsnDtCnL58Q9L4WVgbgIk.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/5PsnDtCnL58Q9L4WVgbgIk.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/5PsnDtCnL58Q9L4WVgbgIk.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/5PsnDtCnL58Q9L4WVgbgIk.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/5PsnDtCnL58Q9L4WVgbgIk.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Reprise",
										"year": 2021,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "18 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/2Z41Eo7V7GVlbnuNSc3ZdT.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/2Z41Eo7V7GVlbnuNSc3ZdT.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/2Z41Eo7V7GVlbnuNSc3ZdT.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/2Z41Eo7V7GVlbnuNSc3ZdT.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/2Z41Eo7V7GVlbnuNSc3ZdT.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/2Z41Eo7V7GVlbnuNSc3ZdT.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/2Z41Eo7V7GVlbnuNSc3ZdT.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/2Z41Eo7V7GVlbnuNSc3ZdT.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Exit Strategy",
										"year": 2021,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "18 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/7B3skS6bdkFIE8lIo9e996.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/7B3skS6bdkFIE8lIo9e996.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/7B3skS6bdkFIE8lIo9e996.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/7B3skS6bdkFIE8lIo9e996.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/7B3skS6bdkFIE8lIo9e996.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/7B3skS6bdkFIE8lIo9e996.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/7B3skS6bdkFIE8lIo9e996.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/7B3skS6bdkFIE8lIo9e996.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "The End of Questions",
										"year": 2021,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "18 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/2wTgxAIuK7gqUWbsm0l5E.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/2wTgxAIuK7gqUWbsm0l5E.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/2wTgxAIuK7gqUWbsm0l5E.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/2wTgxAIuK7gqUWbsm0l5E.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/2wTgxAIuK7gqUWbsm0l5E.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/2wTgxAIuK7gqUWbsm0l5E.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/2wTgxAIuK7gqUWbsm0l5E.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/2wTgxAIuK7gqUWbsm0l5E.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Wilderness",
										"year": 2021,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "35.5 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/4k1vZ0pqzIgB2ktCLpR20z.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/4k1vZ0pqzIgB2ktCLpR20z.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/4k1vZ0pqzIgB2ktCLpR20z.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/4k1vZ0pqzIgB2ktCLpR20z.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/4k1vZ0pqzIgB2ktCLpR20z.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/4k1vZ0pqzIgB2ktCLpR20z.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/4k1vZ0pqzIgB2ktCLpR20z.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/4k1vZ0pqzIgB2ktCLpR20z.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Waiting",
										"year": 2021,
										"medium": "charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "18 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/l3jarZNznq8dogQqTwNTy.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/l3jarZNznq8dogQqTwNTy.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/l3jarZNznq8dogQqTwNTy.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/l3jarZNznq8dogQqTwNTy.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/l3jarZNznq8dogQqTwNTy.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/l3jarZNznq8dogQqTwNTy.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/l3jarZNznq8dogQqTwNTy.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/l3jarZNznq8dogQqTwNTy.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "False Dawn",
										"year": 2021,
										"medium": "charcoal, Indian ink and emulsion on Fabriano",
										"dimensions": "17.5 x 26cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/att7F4J70eDQdDIF5.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/att7F4J70eDQdDIF5.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/att7F4J70eDQdDIF5.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/att7F4J70eDQdDIF5.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/att7F4J70eDQdDIF5.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/att7F4J70eDQdDIF5.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/att7F4J70eDQdDIF5.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/att7F4J70eDQdDIF5.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Damaged Goods",
										"year": 2021,
										"medium": "charcoal, Indian ink and emulsion on Fabriano",
										"dimensions": "24.8 x 18cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attzIRkXh638XEw1k.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attzIRkXh638XEw1k.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attzIRkXh638XEw1k.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attzIRkXh638XEw1k.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attzIRkXh638XEw1k.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attzIRkXh638XEw1k.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attzIRkXh638XEw1k.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attzIRkXh638XEw1k.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "About Turn",
										"year": 2021,
										"medium": "charcoal, Indian ink and emulsion on Fabriano",
										"dimensions": "25 x 18cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attqZhjzozX7DHLKJ.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attqZhjzozX7DHLKJ.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attqZhjzozX7DHLKJ.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attqZhjzozX7DHLKJ.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attqZhjzozX7DHLKJ.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attqZhjzozX7DHLKJ.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attqZhjzozX7DHLKJ.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attqZhjzozX7DHLKJ.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Fallen Angel",
										"year": 2021,
										"medium": "charcoal, Indian ink and emulsion on Fabriano",
										"dimensions": "17.5 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/att2kbq78DPkJPveZ.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/att2kbq78DPkJPveZ.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/att2kbq78DPkJPveZ.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/att2kbq78DPkJPveZ.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/att2kbq78DPkJPveZ.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/att2kbq78DPkJPveZ.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/att2kbq78DPkJPveZ.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/att2kbq78DPkJPveZ.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Mute Facts",
										"year": 2021,
										"medium": "charcoal, Indian ink and emulsion on Fabriano",
										"dimensions": "17.5 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attCft0B6S4vMZScm.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attCft0B6S4vMZScm.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attCft0B6S4vMZScm.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attCft0B6S4vMZScm.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attCft0B6S4vMZScm.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attCft0B6S4vMZScm.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attCft0B6S4vMZScm.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attCft0B6S4vMZScm.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "On the Level",
										"year": 2020,
										"medium": "charcoal, Indian ink and emulsion on Fabriano",
										"dimensions": "25 x 18cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attjfzYR0UxBatzqW.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attjfzYR0UxBatzqW.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attjfzYR0UxBatzqW.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attjfzYR0UxBatzqW.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attjfzYR0UxBatzqW.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attjfzYR0UxBatzqW.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attjfzYR0UxBatzqW.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attjfzYR0UxBatzqW.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Too Close to Call",
										"year": 2020,
										"medium": "charcoal, Indian ink and emulsion on Fabriano",
										"dimensions": "24.8 x 17.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/att3pZBm0voqS01uY.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/att3pZBm0voqS01uY.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/att3pZBm0voqS01uY.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/att3pZBm0voqS01uY.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/att3pZBm0voqS01uY.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/att3pZBm0voqS01uY.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/att3pZBm0voqS01uY.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/att3pZBm0voqS01uY.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Somewhere Under the Sun",
										"year": 2020,
										"medium": "charcoal, Indian ink and emulsion on Fabriano",
										"dimensions": "17.5 x 20cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attp88XkwQtaGMNNW.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attp88XkwQtaGMNNW.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attp88XkwQtaGMNNW.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attp88XkwQtaGMNNW.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attp88XkwQtaGMNNW.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attp88XkwQtaGMNNW.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attp88XkwQtaGMNNW.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attp88XkwQtaGMNNW.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Stupid and Clever",
										"year": 2021,
										"medium": "charcoal, Indian ink and emulsion on Fabriano",
										"dimensions": "35 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attZvgGjdRi5IRKYG.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attZvgGjdRi5IRKYG.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attZvgGjdRi5IRKYG.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attZvgGjdRi5IRKYG.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attZvgGjdRi5IRKYG.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attZvgGjdRi5IRKYG.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attZvgGjdRi5IRKYG.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attZvgGjdRi5IRKYG.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "The Nature of Truth",
										"year": 2021,
										"medium": "charcoal, Indian ink and emulsion on Fabriano",
										"dimensions": "16 x 25.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attcDIIxSAFMoNMWF.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attcDIIxSAFMoNMWF.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attcDIIxSAFMoNMWF.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attcDIIxSAFMoNMWF.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attcDIIxSAFMoNMWF.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attcDIIxSAFMoNMWF.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attcDIIxSAFMoNMWF.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attcDIIxSAFMoNMWF.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "The Weight of Dust",
										"year": 2021,
										"medium": "charcoal, Indian ink and emulsion on Fabriano",
										"dimensions": "19 x 27cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attQmVK8sTG08rG71.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attQmVK8sTG08rG71.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attQmVK8sTG08rG71.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attQmVK8sTG08rG71.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attQmVK8sTG08rG71.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attQmVK8sTG08rG71.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attQmVK8sTG08rG71.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attQmVK8sTG08rG71.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Yield",
										"year": 2020,
										"medium": "charcoal, Indian ink and emulsion on Fabriano",
										"dimensions": "17.7 x 20cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attWhk8u3tBgGVfck.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attWhk8u3tBgGVfck.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attWhk8u3tBgGVfck.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attWhk8u3tBgGVfck.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attWhk8u3tBgGVfck.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attWhk8u3tBgGVfck.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attWhk8u3tBgGVfck.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attWhk8u3tBgGVfck.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Slippery",
										"year": 2021,
										"medium": "charcoal, Indian ink and emulsion on Fabriano",
										"dimensions": "24.8 x 17.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attTIz4yjKN7j9wNb.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attTIz4yjKN7j9wNb.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attTIz4yjKN7j9wNb.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attTIz4yjKN7j9wNb.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attTIz4yjKN7j9wNb.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attTIz4yjKN7j9wNb.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attTIz4yjKN7j9wNb.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attTIz4yjKN7j9wNb.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Lost Thread",
										"year": 2021,
										"medium": "charcoal, Indian ink and emulsion on Fabriano",
										"dimensions": "18 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attJOtn32e1BC7AHm.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attJOtn32e1BC7AHm.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attJOtn32e1BC7AHm.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attJOtn32e1BC7AHm.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attJOtn32e1BC7AHm.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attJOtn32e1BC7AHm.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attJOtn32e1BC7AHm.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attJOtn32e1BC7AHm.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "What's Left Over",
										"year": 2021,
										"medium": "charcoal, Indian ink and emulsion on Fabriano",
										"dimensions": "17.5 x 26cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attbbhURherfBjudR.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attbbhURherfBjudR.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attbbhURherfBjudR.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attbbhURherfBjudR.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attbbhURherfBjudR.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attbbhURherfBjudR.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attbbhURherfBjudR.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attbbhURherfBjudR.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "I'll know it when I see it",
										"year": 2021,
										"medium": "charcoal, Indian ink and emulsion on Fabriano",
										"dimensions": "24.8 x 17.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attxSJOM5fp6WVJsx.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attxSJOM5fp6WVJsx.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attxSJOM5fp6WVJsx.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attxSJOM5fp6WVJsx.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attxSJOM5fp6WVJsx.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attxSJOM5fp6WVJsx.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attxSJOM5fp6WVJsx.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attxSJOM5fp6WVJsx.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Epiphany",
										"year": 2021,
										"medium": "Charcoal, Indian ink, emulsion and acrylic paint on Fabriano",
										"dimensions": "18 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/2ocSjiirVmLoGZiex3qEGA.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/2ocSjiirVmLoGZiex3qEGA.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/2ocSjiirVmLoGZiex3qEGA.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/2ocSjiirVmLoGZiex3qEGA.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/2ocSjiirVmLoGZiex3qEGA.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/2ocSjiirVmLoGZiex3qEGA.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/2ocSjiirVmLoGZiex3qEGA.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/2ocSjiirVmLoGZiex3qEGA.jpg",
																"width": 1366
														}
												]
										}
								}
						],
						"current": false
				},
				{
						"linkName": "everyday-fictions-painting",
						"name": "Everyday Fictions",
						"type": "Painting",
						"copy": "<h2>EVERYDAY FICTIONS</h2>\n<p></p>",
						"archive": true,
						"coverImage": {
								"fallbackImageUrl": "https://images.tonyhull.com/1024/attkkinMcs1yZMKCy.jpg",
								"imageSizes": [
										{
												"url": "https://images.tonyhull.com/320/attkkinMcs1yZMKCy.jpg",
												"width": 320
										},
										{
												"url": "https://images.tonyhull.com/768/attkkinMcs1yZMKCy.jpg",
												"width": 768
										},
										{
												"url": "https://images.tonyhull.com/640/attkkinMcs1yZMKCy.jpg",
												"width": 640
										},
										{
												"url": "https://images.tonyhull.com/1024/attkkinMcs1yZMKCy.jpg",
												"width": 1024
										},
										{
												"url": "https://images.tonyhull.com/1600/attkkinMcs1yZMKCy.jpg",
												"width": 1600
										},
										{
												"url": "https://images.tonyhull.com/1920/attkkinMcs1yZMKCy.jpg",
												"width": 1920
										},
										{
												"url": "https://images.tonyhull.com/1366/attkkinMcs1yZMKCy.jpg",
												"width": 1366
										}
								]
						},
						"pieces": [
								{
										"title": "It is And It isn't",
										"year": 2017,
										"medium": "oil on oil paint tablet",
										"dimensions": "23 x 35cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attoo5vmb7qoV2mTx.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attoo5vmb7qoV2mTx.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attoo5vmb7qoV2mTx.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attoo5vmb7qoV2mTx.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attoo5vmb7qoV2mTx.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attoo5vmb7qoV2mTx.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attoo5vmb7qoV2mTx.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attoo5vmb7qoV2mTx.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "I Think We were Mistaken",
										"year": 2017,
										"medium": "oil on canvas",
										"dimensions": "24 x 34cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attHIiSDZdIaIQUQu.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attHIiSDZdIaIQUQu.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attHIiSDZdIaIQUQu.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attHIiSDZdIaIQUQu.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attHIiSDZdIaIQUQu.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attHIiSDZdIaIQUQu.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attHIiSDZdIaIQUQu.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attHIiSDZdIaIQUQu.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Needs and Desires",
										"year": 2017,
										"medium": "oil on canvas",
										"dimensions": "25.5 x 24cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/att3sQ61crolLdk36.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/att3sQ61crolLdk36.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/att3sQ61crolLdk36.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/att3sQ61crolLdk36.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/att3sQ61crolLdk36.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/att3sQ61crolLdk36.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/att3sQ61crolLdk36.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/att3sQ61crolLdk36.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Endowment",
										"year": 2017,
										"medium": "oil on canvas",
										"dimensions": "24 x 30cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attF7gYsoSwcucNAy.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attF7gYsoSwcucNAy.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attF7gYsoSwcucNAy.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attF7gYsoSwcucNAy.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attF7gYsoSwcucNAy.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attF7gYsoSwcucNAy.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attF7gYsoSwcucNAy.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attF7gYsoSwcucNAy.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Somewhere or Other",
										"year": 2017,
										"medium": "oil on oil paint tablet",
										"dimensions": "23.5 x 33cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attpEitNsscFSVz9K.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attpEitNsscFSVz9K.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attpEitNsscFSVz9K.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attpEitNsscFSVz9K.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attpEitNsscFSVz9K.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attpEitNsscFSVz9K.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attpEitNsscFSVz9K.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attpEitNsscFSVz9K.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Signals and Noise",
										"year": 2017,
										"medium": "oil on canvas",
										"dimensions": "79 x 131cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attlGNGt2HKNnUjmD.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attlGNGt2HKNnUjmD.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attlGNGt2HKNnUjmD.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attlGNGt2HKNnUjmD.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attlGNGt2HKNnUjmD.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attlGNGt2HKNnUjmD.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attlGNGt2HKNnUjmD.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attlGNGt2HKNnUjmD.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Naivety and Cunning",
										"year": 2017,
										"medium": "oil on canvas",
										"dimensions": "24 x 33.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attcTJtt5q9JaJT6i.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attcTJtt5q9JaJT6i.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attcTJtt5q9JaJT6i.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attcTJtt5q9JaJT6i.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attcTJtt5q9JaJT6i.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attcTJtt5q9JaJT6i.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attcTJtt5q9JaJT6i.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attcTJtt5q9JaJT6i.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Circle",
										"year": 2017,
										"medium": "oil on canvas",
										"dimensions": "24 x 33.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attpixDBJTC1wpDZB.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attpixDBJTC1wpDZB.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attpixDBJTC1wpDZB.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attpixDBJTC1wpDZB.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attpixDBJTC1wpDZB.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attpixDBJTC1wpDZB.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attpixDBJTC1wpDZB.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attpixDBJTC1wpDZB.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "After the Fact",
										"year": 2017,
										"medium": "oil on oil paint tablet",
										"dimensions": "24 x 24cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/atteV7rWunWor2xwf.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/atteV7rWunWor2xwf.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/atteV7rWunWor2xwf.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/atteV7rWunWor2xwf.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/atteV7rWunWor2xwf.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/atteV7rWunWor2xwf.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/atteV7rWunWor2xwf.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/atteV7rWunWor2xwf.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Inheritance",
										"year": 2017,
										"medium": "oil on canvas",
										"dimensions": "26 x 28cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/att0BnOUAi4aUIYIl.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/att0BnOUAi4aUIYIl.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/att0BnOUAi4aUIYIl.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/att0BnOUAi4aUIYIl.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/att0BnOUAi4aUIYIl.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/att0BnOUAi4aUIYIl.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/att0BnOUAi4aUIYIl.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/att0BnOUAi4aUIYIl.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Ways and Means II",
										"year": 2017,
										"medium": "oil on oil paint tablet",
										"dimensions": "35 x 23cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attlekS1HFtwz1PKj.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attlekS1HFtwz1PKj.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attlekS1HFtwz1PKj.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attlekS1HFtwz1PKj.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attlekS1HFtwz1PKj.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attlekS1HFtwz1PKj.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attlekS1HFtwz1PKj.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attlekS1HFtwz1PKj.jpg",
																"width": 1366
														}
												]
										}
								}
						],
						"current": false
				},
				{
						"linkName": "everyday-fictions-drawing",
						"name": "Everyday Fictions",
						"type": "Drawing",
						"copy": "<h2>EVERYDAY FICTIONS</h2>\n<p></p>",
						"archive": true,
						"coverImage": {
								"fallbackImageUrl": "https://images.tonyhull.com/1024/attMPR2CpNnAqy8Tj.jpg",
								"imageSizes": [
										{
												"url": "https://images.tonyhull.com/320/attMPR2CpNnAqy8Tj.jpg",
												"width": 320
										},
										{
												"url": "https://images.tonyhull.com/768/attMPR2CpNnAqy8Tj.jpg",
												"width": 768
										},
										{
												"url": "https://images.tonyhull.com/640/attMPR2CpNnAqy8Tj.jpg",
												"width": 640
										},
										{
												"url": "https://images.tonyhull.com/1024/attMPR2CpNnAqy8Tj.jpg",
												"width": 1024
										},
										{
												"url": "https://images.tonyhull.com/1600/attMPR2CpNnAqy8Tj.jpg",
												"width": 1600
										},
										{
												"url": "https://images.tonyhull.com/1920/attMPR2CpNnAqy8Tj.jpg",
												"width": 1920
										},
										{
												"url": "https://images.tonyhull.com/1366/attMPR2CpNnAqy8Tj.jpg",
												"width": 1366
										}
								]
						},
						"pieces": [
								{
										"title": "After the fact",
										"year": 2017,
										"medium": "ink and charcoal on Fabriano",
										"dimensions": "19.5 x 26.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attJOza1qWOFeo4UO.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attJOza1qWOFeo4UO.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attJOza1qWOFeo4UO.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attJOza1qWOFeo4UO.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attJOza1qWOFeo4UO.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attJOza1qWOFeo4UO.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attJOza1qWOFeo4UO.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attJOza1qWOFeo4UO.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Inheritance",
										"year": 2017,
										"medium": "acrylic and charcoal on paper",
										"dimensions": "40 x 34cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attAXI8QQGoXeAHHU.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attAXI8QQGoXeAHHU.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attAXI8QQGoXeAHHU.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attAXI8QQGoXeAHHU.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attAXI8QQGoXeAHHU.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attAXI8QQGoXeAHHU.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attAXI8QQGoXeAHHU.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attAXI8QQGoXeAHHU.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Out of the Woods",
										"year": 2017,
										"medium": "acrylic and charcoal on paper",
										"dimensions": "27.5 x 40cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attMYgsEtO4QD1HYI.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attMYgsEtO4QD1HYI.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attMYgsEtO4QD1HYI.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attMYgsEtO4QD1HYI.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attMYgsEtO4QD1HYI.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attMYgsEtO4QD1HYI.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attMYgsEtO4QD1HYI.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attMYgsEtO4QD1HYI.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Ring",
										"year": 2017,
										"medium": "ink on Fabriano",
										"dimensions": "30 x 38cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attXKyA0g5roAVBWf.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attXKyA0g5roAVBWf.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attXKyA0g5roAVBWf.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attXKyA0g5roAVBWf.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attXKyA0g5roAVBWf.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attXKyA0g5roAVBWf.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attXKyA0g5roAVBWf.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attXKyA0g5roAVBWf.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Jumpers",
										"year": 2017,
										"medium": "ink on Fabriano",
										"dimensions": "28 x 39cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attndAgeyBLJl8sX1.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attndAgeyBLJl8sX1.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attndAgeyBLJl8sX1.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attndAgeyBLJl8sX1.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attndAgeyBLJl8sX1.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attndAgeyBLJl8sX1.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attndAgeyBLJl8sX1.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attndAgeyBLJl8sX1.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Ways and Means",
										"year": 2017,
										"medium": "ink on Fabriano",
										"dimensions": "24 x 19.5",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attIH4qYNJhREDjSE.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attIH4qYNJhREDjSE.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attIH4qYNJhREDjSE.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attIH4qYNJhREDjSE.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attIH4qYNJhREDjSE.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attIH4qYNJhREDjSE.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attIH4qYNJhREDjSE.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attIH4qYNJhREDjSE.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Everyday Fictions IX",
										"year": 2017,
										"medium": "ink on Fabriano",
										"dimensions": "25 x 20cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attD8Klb83FrEgjOR.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attD8Klb83FrEgjOR.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attD8Klb83FrEgjOR.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attD8Klb83FrEgjOR.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attD8Klb83FrEgjOR.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attD8Klb83FrEgjOR.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attD8Klb83FrEgjOR.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attD8Klb83FrEgjOR.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Everyday FictionsVIII",
										"year": 2017,
										"medium": "ink on Fabriano",
										"dimensions": "25 x 20cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attOV0EOVE0nVyWEu.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attOV0EOVE0nVyWEu.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attOV0EOVE0nVyWEu.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attOV0EOVE0nVyWEu.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attOV0EOVE0nVyWEu.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attOV0EOVE0nVyWEu.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attOV0EOVE0nVyWEu.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attOV0EOVE0nVyWEu.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Star Me and You",
										"year": 2017,
										"medium": "acrylic and charcoal on Fabriano",
										"dimensions": "41.5 x 85cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attBA6YvyH3yjumjB.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attBA6YvyH3yjumjB.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attBA6YvyH3yjumjB.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attBA6YvyH3yjumjB.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attBA6YvyH3yjumjB.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attBA6YvyH3yjumjB.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attBA6YvyH3yjumjB.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attBA6YvyH3yjumjB.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Signals and Noise",
										"year": 2017,
										"medium": "ink and charcoal on Fabriano",
										"dimensions": "48 x 62cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/att71ELRPJ99Z5BVW.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/att71ELRPJ99Z5BVW.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/att71ELRPJ99Z5BVW.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/att71ELRPJ99Z5BVW.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/att71ELRPJ99Z5BVW.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/att71ELRPJ99Z5BVW.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/att71ELRPJ99Z5BVW.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/att71ELRPJ99Z5BVW.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Everyday Fictions XIV",
										"year": 2017,
										"medium": "ink on Fabriano",
										"dimensions": "24 x 20",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attw6yHG0n3YuVFmM.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attw6yHG0n3YuVFmM.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attw6yHG0n3YuVFmM.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attw6yHG0n3YuVFmM.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attw6yHG0n3YuVFmM.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attw6yHG0n3YuVFmM.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attw6yHG0n3YuVFmM.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attw6yHG0n3YuVFmM.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Everyday Fictions IV",
										"year": 2017,
										"medium": "ink on Fabriano",
										"dimensions": "25 x 20cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attzHqxPvmpqePTbt.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attzHqxPvmpqePTbt.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attzHqxPvmpqePTbt.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attzHqxPvmpqePTbt.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attzHqxPvmpqePTbt.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attzHqxPvmpqePTbt.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attzHqxPvmpqePTbt.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attzHqxPvmpqePTbt.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Everyday Fictions XIII",
										"year": 2017,
										"medium": "ink on Fabriano",
										"dimensions": "25 x 20cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attr2B0q3ZhELMqma.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attr2B0q3ZhELMqma.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attr2B0q3ZhELMqma.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attr2B0q3ZhELMqma.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attr2B0q3ZhELMqma.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attr2B0q3ZhELMqma.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attr2B0q3ZhELMqma.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attr2B0q3ZhELMqma.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Everyday Fictions XVII",
										"year": 2017,
										"medium": "ink on Fabriano",
										"dimensions": "25 x 20cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attmyWCZJYTta1Gyy.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attmyWCZJYTta1Gyy.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attmyWCZJYTta1Gyy.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attmyWCZJYTta1Gyy.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attmyWCZJYTta1Gyy.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attmyWCZJYTta1Gyy.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attmyWCZJYTta1Gyy.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attmyWCZJYTta1Gyy.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Everyday Fictions XX",
										"year": 2017,
										"medium": "ink on Fabriano",
										"dimensions": "25 x 20cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/atttJYG9lGDZW74P9.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/atttJYG9lGDZW74P9.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/atttJYG9lGDZW74P9.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/atttJYG9lGDZW74P9.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/atttJYG9lGDZW74P9.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/atttJYG9lGDZW74P9.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/atttJYG9lGDZW74P9.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/atttJYG9lGDZW74P9.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Needs and Desires",
										"year": 2017,
										"medium": "ink on Fabriano",
										"dimensions": "24.5 x 24cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attYAk9JCl9v6uix1.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attYAk9JCl9v6uix1.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attYAk9JCl9v6uix1.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attYAk9JCl9v6uix1.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attYAk9JCl9v6uix1.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attYAk9JCl9v6uix1.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attYAk9JCl9v6uix1.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attYAk9JCl9v6uix1.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Naivety and Cunning",
										"year": 2017,
										"medium": "ink on Fabriano",
										"dimensions": "19.5 x 26.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attjxbKiWuMfUSqRE.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attjxbKiWuMfUSqRE.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attjxbKiWuMfUSqRE.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attjxbKiWuMfUSqRE.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attjxbKiWuMfUSqRE.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attjxbKiWuMfUSqRE.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attjxbKiWuMfUSqRE.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attjxbKiWuMfUSqRE.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Better Left Unsaid",
										"year": 2017,
										"medium": "ink on Fabriano",
										"dimensions": "24 x 19cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attaCeqiu1pguqoBE.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attaCeqiu1pguqoBE.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attaCeqiu1pguqoBE.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attaCeqiu1pguqoBE.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attaCeqiu1pguqoBE.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attaCeqiu1pguqoBE.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attaCeqiu1pguqoBE.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attaCeqiu1pguqoBE.jpg",
																"width": 1366
														}
												]
										}
								}
						],
						"current": false
				},
				{
						"linkName": "how-to-make-friends",
						"name": "How to Make Friends",
						"type": "Drawing",
						"copy": "<h2>HOW TO MAKE FRIENDS</h2>\n<p></p>",
						"archive": true,
						"coverImage": {
								"fallbackImageUrl": "https://images.tonyhull.com/1024/attodEBY7iZ5ui6dD.jpg",
								"imageSizes": [
										{
												"url": "https://images.tonyhull.com/320/attodEBY7iZ5ui6dD.jpg",
												"width": 320
										},
										{
												"url": "https://images.tonyhull.com/768/attodEBY7iZ5ui6dD.jpg",
												"width": 768
										},
										{
												"url": "https://images.tonyhull.com/640/attodEBY7iZ5ui6dD.jpg",
												"width": 640
										},
										{
												"url": "https://images.tonyhull.com/1024/attodEBY7iZ5ui6dD.jpg",
												"width": 1024
										},
										{
												"url": "https://images.tonyhull.com/1600/attodEBY7iZ5ui6dD.jpg",
												"width": 1600
										},
										{
												"url": "https://images.tonyhull.com/1920/attodEBY7iZ5ui6dD.jpg",
												"width": 1920
										},
										{
												"url": "https://images.tonyhull.com/1366/attodEBY7iZ5ui6dD.jpg",
												"width": 1366
										}
								]
						},
						"pieces": [
								{
										"title": "Untitled Drawing I",
										"year": 2009,
										"medium": "ink and charcoal on Heritage",
										"dimensions": "31 x 26cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attAeM7exNe1ju3qS.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attAeM7exNe1ju3qS.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attAeM7exNe1ju3qS.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attAeM7exNe1ju3qS.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attAeM7exNe1ju3qS.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attAeM7exNe1ju3qS.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attAeM7exNe1ju3qS.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attAeM7exNe1ju3qS.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Untitled Drawing III",
										"year": 2010,
										"medium": "ink and charcoal on Heritage",
										"dimensions": "31 x 26cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/att9TLQ30KJMOSQAY.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/att9TLQ30KJMOSQAY.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/att9TLQ30KJMOSQAY.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/att9TLQ30KJMOSQAY.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/att9TLQ30KJMOSQAY.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/att9TLQ30KJMOSQAY.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/att9TLQ30KJMOSQAY.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/att9TLQ30KJMOSQAY.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Untitled Drawing XI",
										"year": 2010,
										"medium": "ink and charcoal on Heritage",
										"dimensions": "68.5 x 50.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attwXbSieqdrRZUAD.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attwXbSieqdrRZUAD.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attwXbSieqdrRZUAD.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attwXbSieqdrRZUAD.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attwXbSieqdrRZUAD.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attwXbSieqdrRZUAD.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attwXbSieqdrRZUAD.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attwXbSieqdrRZUAD.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Untitled Drawing VI",
										"year": 2010,
										"medium": "ink and charcoal on Heritage",
										"dimensions": "68.5 x 50.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attUqtqg62b09vnNb.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attUqtqg62b09vnNb.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attUqtqg62b09vnNb.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attUqtqg62b09vnNb.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attUqtqg62b09vnNb.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attUqtqg62b09vnNb.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attUqtqg62b09vnNb.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attUqtqg62b09vnNb.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Untitled VII",
										"year": 2009,
										"medium": "ink and charcoal on Heritage",
										"dimensions": "68.5 x 50.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attqFRM0mQiEcC7qo.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attqFRM0mQiEcC7qo.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attqFRM0mQiEcC7qo.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attqFRM0mQiEcC7qo.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attqFRM0mQiEcC7qo.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attqFRM0mQiEcC7qo.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attqFRM0mQiEcC7qo.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attqFRM0mQiEcC7qo.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Untitled XII",
										"year": 2010,
										"medium": "ink and charcoal on Heritage",
										"dimensions": "68.5 x 60.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attk5Bvj9t2Iqh3ec.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attk5Bvj9t2Iqh3ec.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attk5Bvj9t2Iqh3ec.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attk5Bvj9t2Iqh3ec.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attk5Bvj9t2Iqh3ec.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attk5Bvj9t2Iqh3ec.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attk5Bvj9t2Iqh3ec.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attk5Bvj9t2Iqh3ec.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Untitled II",
										"year": 2009,
										"medium": "ink and charcoal on Heritage",
										"dimensions": "31 x 26cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/att6wKyOSS7LXTCbM.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/att6wKyOSS7LXTCbM.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/att6wKyOSS7LXTCbM.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/att6wKyOSS7LXTCbM.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/att6wKyOSS7LXTCbM.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/att6wKyOSS7LXTCbM.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/att6wKyOSS7LXTCbM.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/att6wKyOSS7LXTCbM.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Untitled IV",
										"year": 2009,
										"medium": "ink and charcoal on Heritage",
										"dimensions": "68.5 x 50.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attqslKYRtcXHk8cf.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attqslKYRtcXHk8cf.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attqslKYRtcXHk8cf.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attqslKYRtcXHk8cf.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attqslKYRtcXHk8cf.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attqslKYRtcXHk8cf.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attqslKYRtcXHk8cf.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attqslKYRtcXHk8cf.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Untitled VIII",
										"year": 2010,
										"medium": "ink and charcoal on Heritage",
										"dimensions": "31 x 26cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attKCRD8kxjf2AFr7.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attKCRD8kxjf2AFr7.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attKCRD8kxjf2AFr7.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attKCRD8kxjf2AFr7.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attKCRD8kxjf2AFr7.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attKCRD8kxjf2AFr7.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attKCRD8kxjf2AFr7.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attKCRD8kxjf2AFr7.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Untitled X",
										"year": 2009,
										"medium": "ink and charcoal on Heritage",
										"dimensions": "68.5 x 50.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attyKDBM9M3XWZsbi.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attyKDBM9M3XWZsbi.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attyKDBM9M3XWZsbi.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attyKDBM9M3XWZsbi.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attyKDBM9M3XWZsbi.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attyKDBM9M3XWZsbi.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attyKDBM9M3XWZsbi.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attyKDBM9M3XWZsbi.jpg",
																"width": 1366
														}
												]
										}
								}
						],
						"current": false
				},
				{
						"linkName": "temporary-futures",
						"name": "Temporary Futures",
						"type": "Painting",
						"copy": "<h2>TEMPORARY FUTURES</h2>\n<p></p>",
						"archive": true,
						"coverImage": {
								"fallbackImageUrl": "https://images.tonyhull.com/1024/attxvq7RUkiIUdzvn.jpg",
								"imageSizes": [
										{
												"url": "https://images.tonyhull.com/320/attxvq7RUkiIUdzvn.jpg",
												"width": 320
										},
										{
												"url": "https://images.tonyhull.com/768/attxvq7RUkiIUdzvn.jpg",
												"width": 768
										},
										{
												"url": "https://images.tonyhull.com/640/attxvq7RUkiIUdzvn.jpg",
												"width": 640
										},
										{
												"url": "https://images.tonyhull.com/1024/attxvq7RUkiIUdzvn.jpg",
												"width": 1024
										},
										{
												"url": "https://images.tonyhull.com/1600/attxvq7RUkiIUdzvn.jpg",
												"width": 1600
										},
										{
												"url": "https://images.tonyhull.com/1920/attxvq7RUkiIUdzvn.jpg",
												"width": 1920
										},
										{
												"url": "https://images.tonyhull.com/1366/attxvq7RUkiIUdzvn.jpg",
												"width": 1366
										}
								]
						},
						"pieces": [
								{
										"title": "Standing in Line",
										"year": 2016,
										"medium": "oil on canvas",
										"dimensions": "37.5 x 45.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attAbaJza0fzjDrpD.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attAbaJza0fzjDrpD.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attAbaJza0fzjDrpD.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attAbaJza0fzjDrpD.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attAbaJza0fzjDrpD.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attAbaJza0fzjDrpD.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attAbaJza0fzjDrpD.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attAbaJza0fzjDrpD.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Front Runner",
										"year": 2016,
										"medium": "oil on canvas",
										"dimensions": "44.5 x 51",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attfOhYacIzZjWikh.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attfOhYacIzZjWikh.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attfOhYacIzZjWikh.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attfOhYacIzZjWikh.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attfOhYacIzZjWikh.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attfOhYacIzZjWikh.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attfOhYacIzZjWikh.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attfOhYacIzZjWikh.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Walking in Lines",
										"year": 2016,
										"medium": "oil on canvas",
										"dimensions": "35.5 x 47cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attngWQIo46Ezs3hd.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attngWQIo46Ezs3hd.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attngWQIo46Ezs3hd.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attngWQIo46Ezs3hd.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attngWQIo46Ezs3hd.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attngWQIo46Ezs3hd.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attngWQIo46Ezs3hd.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attngWQIo46Ezs3hd.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Recurrences",
										"year": 2016,
										"medium": "oil on canvas",
										"dimensions": "88 x 144cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attKOWDj7TzFN3Wyc.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attKOWDj7TzFN3Wyc.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attKOWDj7TzFN3Wyc.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attKOWDj7TzFN3Wyc.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attKOWDj7TzFN3Wyc.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attKOWDj7TzFN3Wyc.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attKOWDj7TzFN3Wyc.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attKOWDj7TzFN3Wyc.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Flood",
										"year": 2016,
										"medium": "oil on canvas",
										"dimensions": "35 x 40.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/att1Xy1ZR2aaM8K56.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/att1Xy1ZR2aaM8K56.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/att1Xy1ZR2aaM8K56.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/att1Xy1ZR2aaM8K56.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/att1Xy1ZR2aaM8K56.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/att1Xy1ZR2aaM8K56.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/att1Xy1ZR2aaM8K56.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/att1Xy1ZR2aaM8K56.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Lean",
										"year": 2016,
										"medium": "oil on canvas",
										"dimensions": "54 x 114.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attet6cvH87xGwxtK.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attet6cvH87xGwxtK.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attet6cvH87xGwxtK.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attet6cvH87xGwxtK.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attet6cvH87xGwxtK.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attet6cvH87xGwxtK.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attet6cvH87xGwxtK.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attet6cvH87xGwxtK.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Alone",
										"year": 2016,
										"medium": "oil on linen",
										"dimensions": "120 x 200cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attlHRzmd9AXfjphd.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attlHRzmd9AXfjphd.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attlHRzmd9AXfjphd.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attlHRzmd9AXfjphd.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attlHRzmd9AXfjphd.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attlHRzmd9AXfjphd.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attlHRzmd9AXfjphd.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attlHRzmd9AXfjphd.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Stretch",
										"year": 2016,
										"medium": "oil on canvas",
										"dimensions": "69.5 x 56cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attt45MjfBhY2PbHd.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attt45MjfBhY2PbHd.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attt45MjfBhY2PbHd.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attt45MjfBhY2PbHd.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attt45MjfBhY2PbHd.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attt45MjfBhY2PbHd.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attt45MjfBhY2PbHd.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attt45MjfBhY2PbHd.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Non Place",
										"year": 2016,
										"medium": "oil on canvas",
										"dimensions": "93 x 116cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attyrbRIiAviKl6SO.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attyrbRIiAviKl6SO.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attyrbRIiAviKl6SO.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attyrbRIiAviKl6SO.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attyrbRIiAviKl6SO.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attyrbRIiAviKl6SO.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attyrbRIiAviKl6SO.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attyrbRIiAviKl6SO.jpg",
																"width": 1366
														}
												]
										}
								}
						],
						"current": false
				},
				{
						"linkName": "uncertain-affinities",
						"name": "Uncertain Affinities",
						"type": "Painting",
						"copy": "<h2>UNCERTAIN AFFINITIES</h2>\n<p></p>",
						"archive": true,
						"coverImage": {
								"fallbackImageUrl": "https://images.tonyhull.com/1024/att7Xvysv4EYSuvWm.jpg",
								"imageSizes": [
										{
												"url": "https://images.tonyhull.com/320/att7Xvysv4EYSuvWm.jpg",
												"width": 320
										},
										{
												"url": "https://images.tonyhull.com/768/att7Xvysv4EYSuvWm.jpg",
												"width": 768
										},
										{
												"url": "https://images.tonyhull.com/640/att7Xvysv4EYSuvWm.jpg",
												"width": 640
										},
										{
												"url": "https://images.tonyhull.com/1024/att7Xvysv4EYSuvWm.jpg",
												"width": 1024
										},
										{
												"url": "https://images.tonyhull.com/1600/att7Xvysv4EYSuvWm.jpg",
												"width": 1600
										},
										{
												"url": "https://images.tonyhull.com/1920/att7Xvysv4EYSuvWm.jpg",
												"width": 1920
										},
										{
												"url": "https://images.tonyhull.com/1366/att7Xvysv4EYSuvWm.jpg",
												"width": 1366
										}
								]
						},
						"pieces": [
								{
										"title": "First Light",
										"year": 2015,
										"medium": "oil on canvas",
										"dimensions": "116 x 93cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attOvB4onHnrT4w1c.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attOvB4onHnrT4w1c.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attOvB4onHnrT4w1c.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attOvB4onHnrT4w1c.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attOvB4onHnrT4w1c.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attOvB4onHnrT4w1c.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attOvB4onHnrT4w1c.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attOvB4onHnrT4w1c.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Unequal Symmetries",
										"year": 2015,
										"medium": "oil on canvas",
										"dimensions": "79 x 131",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attSjOtC1fo8tUcsW.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attSjOtC1fo8tUcsW.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attSjOtC1fo8tUcsW.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attSjOtC1fo8tUcsW.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attSjOtC1fo8tUcsW.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attSjOtC1fo8tUcsW.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attSjOtC1fo8tUcsW.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attSjOtC1fo8tUcsW.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Temporary Future",
										"year": 2015,
										"medium": "oil on canvas",
										"dimensions": "116 x 93cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attXk9cJI80RG6Vol.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attXk9cJI80RG6Vol.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attXk9cJI80RG6Vol.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attXk9cJI80RG6Vol.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attXk9cJI80RG6Vol.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attXk9cJI80RG6Vol.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attXk9cJI80RG6Vol.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attXk9cJI80RG6Vol.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Need and Desire",
										"year": 2015,
										"medium": "oil on canvas",
										"dimensions": "120 x 168cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attD6g1aaBBTDaK6U.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attD6g1aaBBTDaK6U.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attD6g1aaBBTDaK6U.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attD6g1aaBBTDaK6U.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attD6g1aaBBTDaK6U.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attD6g1aaBBTDaK6U.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attD6g1aaBBTDaK6U.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attD6g1aaBBTDaK6U.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Happy Together",
										"year": 2015,
										"medium": "oil on canvas",
										"dimensions": "50 x 38cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attT34R6OqLNd0Enk.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attT34R6OqLNd0Enk.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attT34R6OqLNd0Enk.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attT34R6OqLNd0Enk.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attT34R6OqLNd0Enk.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attT34R6OqLNd0Enk.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attT34R6OqLNd0Enk.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attT34R6OqLNd0Enk.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Unintended Consequences",
										"year": 2015,
										"medium": "oil on canvas",
										"dimensions": "61 x 48.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attpOzQhLJAL8hoKj.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attpOzQhLJAL8hoKj.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attpOzQhLJAL8hoKj.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attpOzQhLJAL8hoKj.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attpOzQhLJAL8hoKj.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attpOzQhLJAL8hoKj.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attpOzQhLJAL8hoKj.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attpOzQhLJAL8hoKj.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "One Thing and Another",
										"year": 2015,
										"medium": "oil on canvas",
										"dimensions": "26.5 x 40cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attcZV1taiIXAeqkc.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attcZV1taiIXAeqkc.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attcZV1taiIXAeqkc.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attcZV1taiIXAeqkc.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attcZV1taiIXAeqkc.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attcZV1taiIXAeqkc.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attcZV1taiIXAeqkc.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attcZV1taiIXAeqkc.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Facts and Other Negotiables",
										"year": 2015,
										"medium": "oil on canvas",
										"dimensions": "60.5 x 123cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attb2GTx6YeuDe9rd.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attb2GTx6YeuDe9rd.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attb2GTx6YeuDe9rd.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attb2GTx6YeuDe9rd.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attb2GTx6YeuDe9rd.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attb2GTx6YeuDe9rd.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attb2GTx6YeuDe9rd.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attb2GTx6YeuDe9rd.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Scheme of Thought",
										"year": 2015,
										"medium": "oil on canvas",
										"dimensions": "122 x 153cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attiKXcC4y5Wcpiy8.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attiKXcC4y5Wcpiy8.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attiKXcC4y5Wcpiy8.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attiKXcC4y5Wcpiy8.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attiKXcC4y5Wcpiy8.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attiKXcC4y5Wcpiy8.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attiKXcC4y5Wcpiy8.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attiKXcC4y5Wcpiy8.jpg",
																"width": 1366
														}
												]
										}
								}
						],
						"current": false
				},
				{
						"linkName": "friend-of-a-friend",
						"name": "Friend of a Friend",
						"type": "Painting",
						"copy": "<h2>FRIEND OF A FRIEND review</h2>\n<p>London based artist Tony Hull\u2019s latest series of oil on canvas are playful studies on contemporary iconography and value systems within the context of 16th century Flemish masterpieces. Layers upon layers of paint push Hull\u2019s subjects\u2014all children\u2014further into contextual oblivion. We struggle to comprehend the 16th century \u201coriginals\u201d from Hull\u2019s contemporary applications. A confused melancholy permeates Hull\u2019s work, and we approach the altered reference of Art History past as one approaches a graffitied street sign. An image that we have collectively grown to equate with a definitive function or meaning has been tampered with.</p>\n<p>We are initially only conscious of what has been altered, falsely believing that we have full understanding of the image\u2019s \u201coriginal\u201d intention. To stop. To yield. Not to loiter. To sit still. Hull\u2019s technique is perfectly suited to the task of stylistic mimicry. His irreverent alteration of centuries old masterpieces is tempered in his reverent, bordering on religious, technique. Centuries collide, and the dust clouds of school room stuffiness that has come to surround the old masters dissipates. They no longer seem so distant. Colors that imply brevity streak across the traditionally somber colors of our fondly remembered Flemish fathers; oil drips sloppily down the canvas and a staccato of brush strokes and scratches almost etch each child into their traditional pose and starched, dated clothing. A bright streak of blue. Of red. A familiar wallpaper print. A dangling filtered cigarette and thick framed glasses (quintessential hipster gear). Batman\u2019s mask. There is a place for all, but it\u2019s hard to put your finger exactly where that place might be or in what alternate universe it may reside.</p>\n<p>Hull must have spent a lot of time literally watching the paint dry, waiting with bated breath for the next application. And the next. All while keeping the referential integrity of the \u201coriginals\u201d and without tipping the scales too heavily in the favor of one time, space or moment.</p>\n<p>Natalie Fasano 2011 PhotoSynth Project New York</p>\n<p><a href=\"http://www.youtube.com/watch?v=cBJJfcSxAFA\" target=\"_blank\">Friend of a Friend interview</a></p>",
						"archive": true,
						"coverImage": {
								"fallbackImageUrl": "https://images.tonyhull.com/1024/attcmR676szZxYIEA.jpg",
								"imageSizes": [
										{
												"url": "https://images.tonyhull.com/320/attcmR676szZxYIEA.jpg",
												"width": 320
										},
										{
												"url": "https://images.tonyhull.com/768/attcmR676szZxYIEA.jpg",
												"width": 768
										},
										{
												"url": "https://images.tonyhull.com/640/attcmR676szZxYIEA.jpg",
												"width": 640
										},
										{
												"url": "https://images.tonyhull.com/1024/attcmR676szZxYIEA.jpg",
												"width": 1024
										},
										{
												"url": "https://images.tonyhull.com/1600/attcmR676szZxYIEA.jpg",
												"width": 1600
										},
										{
												"url": "https://images.tonyhull.com/1920/attcmR676szZxYIEA.jpg",
												"width": 1920
										},
										{
												"url": "https://images.tonyhull.com/1366/attcmR676szZxYIEA.jpg",
												"width": 1366
										}
								]
						},
						"pieces": [
								{
										"title": "With a Sponge and a Rusty Spanner",
										"year": 2012,
										"medium": "oil on canvas",
										"dimensions": "61 x 40cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attqc8fqKRniVWalu.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attqc8fqKRniVWalu.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attqc8fqKRniVWalu.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attqc8fqKRniVWalu.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attqc8fqKRniVWalu.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attqc8fqKRniVWalu.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attqc8fqKRniVWalu.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attqc8fqKRniVWalu.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Friend of a Friend",
										"year": 2010,
										"medium": "oil on canvas",
										"dimensions": "99.5 x 78cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attYS2vWehfpJ04xh.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attYS2vWehfpJ04xh.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attYS2vWehfpJ04xh.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attYS2vWehfpJ04xh.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attYS2vWehfpJ04xh.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attYS2vWehfpJ04xh.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attYS2vWehfpJ04xh.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attYS2vWehfpJ04xh.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Fiend",
										"year": 2011,
										"medium": "oil on canvas",
										"dimensions": "52.5 x 43cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attGiIDNHn05LRDDK.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attGiIDNHn05LRDDK.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attGiIDNHn05LRDDK.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attGiIDNHn05LRDDK.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attGiIDNHn05LRDDK.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attGiIDNHn05LRDDK.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attGiIDNHn05LRDDK.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attGiIDNHn05LRDDK.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Inger's Girl",
										"year": 2012,
										"medium": "oil on canvas",
										"dimensions": "120 x 168cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attWbddTdKwG6qD2b.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attWbddTdKwG6qD2b.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attWbddTdKwG6qD2b.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attWbddTdKwG6qD2b.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attWbddTdKwG6qD2b.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attWbddTdKwG6qD2b.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attWbddTdKwG6qD2b.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attWbddTdKwG6qD2b.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Hot Under the Collar",
										"year": 2013,
										"medium": "oil on canvas",
										"dimensions": "56 x 35cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attLDPDB3CUX34DAI.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attLDPDB3CUX34DAI.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attLDPDB3CUX34DAI.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attLDPDB3CUX34DAI.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attLDPDB3CUX34DAI.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attLDPDB3CUX34DAI.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attLDPDB3CUX34DAI.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attLDPDB3CUX34DAI.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Final Frontier",
										"year": 2013,
										"medium": "oil on canvas",
										"dimensions": "47.5 x 33.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attT2Tm5BZMhtg8ZZ.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attT2Tm5BZMhtg8ZZ.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attT2Tm5BZMhtg8ZZ.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attT2Tm5BZMhtg8ZZ.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attT2Tm5BZMhtg8ZZ.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attT2Tm5BZMhtg8ZZ.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attT2Tm5BZMhtg8ZZ.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attT2Tm5BZMhtg8ZZ.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Doily",
										"year": 2010,
										"medium": "oil on canvas",
										"dimensions": "99.5 x 78cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attlQ4TXNUMxikdDi.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attlQ4TXNUMxikdDi.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attlQ4TXNUMxikdDi.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attlQ4TXNUMxikdDi.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attlQ4TXNUMxikdDi.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attlQ4TXNUMxikdDi.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attlQ4TXNUMxikdDi.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attlQ4TXNUMxikdDi.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Two Boys",
										"year": 2012,
										"medium": "oil on canvas",
										"dimensions": "46 x 57cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/atttbrj7QQ4Ov3UD6.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/atttbrj7QQ4Ov3UD6.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/atttbrj7QQ4Ov3UD6.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/atttbrj7QQ4Ov3UD6.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/atttbrj7QQ4Ov3UD6.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/atttbrj7QQ4Ov3UD6.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/atttbrj7QQ4Ov3UD6.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/atttbrj7QQ4Ov3UD6.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Degrees of Separation",
										"year": 2013,
										"medium": "oil on canvas",
										"dimensions": "41 x 51.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attgIvR2jGDk3dMOy.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attgIvR2jGDk3dMOy.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attgIvR2jGDk3dMOy.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attgIvR2jGDk3dMOy.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attgIvR2jGDk3dMOy.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attgIvR2jGDk3dMOy.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attgIvR2jGDk3dMOy.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attgIvR2jGDk3dMOy.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "I Could Have Been Three",
										"year": 2013,
										"medium": "oil on canvas",
										"dimensions": "41.5 x 60cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attEpM2MMwpoy4Awv.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attEpM2MMwpoy4Awv.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attEpM2MMwpoy4Awv.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attEpM2MMwpoy4Awv.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attEpM2MMwpoy4Awv.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attEpM2MMwpoy4Awv.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attEpM2MMwpoy4Awv.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attEpM2MMwpoy4Awv.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "The Mask",
										"year": 2012,
										"medium": "oil on canvas ",
										"dimensions": "47.5cm x 62cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attrhMVQq6n6TiFjM.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attrhMVQq6n6TiFjM.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attrhMVQq6n6TiFjM.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attrhMVQq6n6TiFjM.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attrhMVQq6n6TiFjM.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attrhMVQq6n6TiFjM.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attrhMVQq6n6TiFjM.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attrhMVQq6n6TiFjM.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Boy with Toothpick",
										"year": 2012,
										"medium": "oil on canvas",
										"dimensions": "39 x 25cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attr0R95SbVqvljNK.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attr0R95SbVqvljNK.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attr0R95SbVqvljNK.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attr0R95SbVqvljNK.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attr0R95SbVqvljNK.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attr0R95SbVqvljNK.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attr0R95SbVqvljNK.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attr0R95SbVqvljNK.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Little Louis",
										"year": 2013,
										"medium": "oil on canvas",
										"dimensions": "28.5 x 22.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attSR5Ajh4ZOFJ3Bz.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attSR5Ajh4ZOFJ3Bz.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attSR5Ajh4ZOFJ3Bz.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attSR5Ajh4ZOFJ3Bz.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attSR5Ajh4ZOFJ3Bz.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attSR5Ajh4ZOFJ3Bz.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attSR5Ajh4ZOFJ3Bz.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attSR5Ajh4ZOFJ3Bz.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "In Make Up",
										"year": 2014,
										"medium": "oil on canvas",
										"dimensions": "32.5 x 40cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attYXOcWOlTFpJOsG.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attYXOcWOlTFpJOsG.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attYXOcWOlTFpJOsG.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attYXOcWOlTFpJOsG.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attYXOcWOlTFpJOsG.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attYXOcWOlTFpJOsG.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attYXOcWOlTFpJOsG.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attYXOcWOlTFpJOsG.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Invader",
										"year": 2013,
										"medium": "oil on canvas",
										"dimensions": "46.5 x 58cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attZmxBElZDdTuRXr.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attZmxBElZDdTuRXr.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attZmxBElZDdTuRXr.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attZmxBElZDdTuRXr.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attZmxBElZDdTuRXr.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attZmxBElZDdTuRXr.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attZmxBElZDdTuRXr.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attZmxBElZDdTuRXr.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "I Could Have Been One",
										"year": 2012,
										"medium": "oil on linen",
										"dimensions": "120 x 200cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attwQWb7y9VfZBjum.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attwQWb7y9VfZBjum.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attwQWb7y9VfZBjum.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attwQWb7y9VfZBjum.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attwQWb7y9VfZBjum.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attwQWb7y9VfZBjum.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attwQWb7y9VfZBjum.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attwQWb7y9VfZBjum.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Young and American",
										"year": 2011,
										"medium": "oil on linen",
										"dimensions": "120 x 200cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/atthMw7qD1uO85Ghg.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/atthMw7qD1uO85Ghg.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/atthMw7qD1uO85Ghg.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/atthMw7qD1uO85Ghg.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/atthMw7qD1uO85Ghg.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/atthMw7qD1uO85Ghg.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/atthMw7qD1uO85Ghg.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/atthMw7qD1uO85Ghg.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Great White (Shades)",
										"year": 2011,
										"medium": "oil on linen",
										"dimensions": "120 x 200cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attmAIE7AtYRbYyiQ.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attmAIE7AtYRbYyiQ.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attmAIE7AtYRbYyiQ.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attmAIE7AtYRbYyiQ.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attmAIE7AtYRbYyiQ.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attmAIE7AtYRbYyiQ.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attmAIE7AtYRbYyiQ.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attmAIE7AtYRbYyiQ.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Baby with the Peal (Earring)",
										"year": 2011,
										"medium": "oil on canvas",
										"dimensions": "51 x 65cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attn1XJXBfw2yrcJy.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attn1XJXBfw2yrcJy.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attn1XJXBfw2yrcJy.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attn1XJXBfw2yrcJy.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attn1XJXBfw2yrcJy.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attn1XJXBfw2yrcJy.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attn1XJXBfw2yrcJy.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attn1XJXBfw2yrcJy.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Sunday mask",
										"year": 2011,
										"medium": "oil on canvas",
										"dimensions": "70 x 60.5cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attrjJKQKGIAyJEdt.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attrjJKQKGIAyJEdt.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attrjJKQKGIAyJEdt.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attrjJKQKGIAyJEdt.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attrjJKQKGIAyJEdt.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attrjJKQKGIAyJEdt.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attrjJKQKGIAyJEdt.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attrjJKQKGIAyJEdt.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Still Life with Credit Card",
										"year": 2012,
										"medium": "oil on canvas",
										"dimensions": "25 x 40cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attABcprRyHMhz1de.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attABcprRyHMhz1de.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attABcprRyHMhz1de.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attABcprRyHMhz1de.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attABcprRyHMhz1de.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attABcprRyHMhz1de.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attABcprRyHMhz1de.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attABcprRyHMhz1de.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Still Life with Oysters and Soldier",
										"year": 2012,
										"medium": "oil on canvas",
										"dimensions": "25 x 40cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attQtO4aeCPtT2nPR.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attQtO4aeCPtT2nPR.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attQtO4aeCPtT2nPR.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attQtO4aeCPtT2nPR.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attQtO4aeCPtT2nPR.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attQtO4aeCPtT2nPR.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attQtO4aeCPtT2nPR.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attQtO4aeCPtT2nPR.jpg",
																"width": 1366
														}
												]
										}
								}
						],
						"current": false
				},
				{
						"linkName": "preferred-method-drawings",
						"name": "Preferred Method",
						"type": "Drawing",
						"copy": "<h2>PREFERRED METHOD</h2>\n<p>Making these works, I was interested in how the careful build of a drawing could both reveal the method of its making and at the same time imply a kind of cover up of the source material. The motifs involved are often hard to place yet relate principally to the iconography of money: its insignia, patterns and watermarks. I wondered whether the explicit nature of the technique could camouflage and hold in check money\u2019s blunt associations with exchange value or commodification.</p>",
						"archive": true,
						"coverImage": {
								"fallbackImageUrl": "https://images.tonyhull.com/1024/attpnoOJBCsLCzlEA.jpg",
								"imageSizes": [
										{
												"url": "https://images.tonyhull.com/320/attpnoOJBCsLCzlEA.jpg",
												"width": 320
										},
										{
												"url": "https://images.tonyhull.com/768/attpnoOJBCsLCzlEA.jpg",
												"width": 768
										},
										{
												"url": "https://images.tonyhull.com/640/attpnoOJBCsLCzlEA.jpg",
												"width": 640
										},
										{
												"url": "https://images.tonyhull.com/1024/attpnoOJBCsLCzlEA.jpg",
												"width": 1024
										},
										{
												"url": "https://images.tonyhull.com/1600/attpnoOJBCsLCzlEA.jpg",
												"width": 1600
										},
										{
												"url": "https://images.tonyhull.com/1920/attpnoOJBCsLCzlEA.jpg",
												"width": 1920
										},
										{
												"url": "https://images.tonyhull.com/1366/attpnoOJBCsLCzlEA.jpg",
												"width": 1366
										}
								]
						},
						"pieces": [
								{
										"title": "One Way Street",
										"year": 2008,
										"medium": "charcoal, pastel and ink on Heritage",
										"dimensions": "74 x 62cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attLLQpBRmjXuCamn.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attLLQpBRmjXuCamn.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attLLQpBRmjXuCamn.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attLLQpBRmjXuCamn.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attLLQpBRmjXuCamn.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attLLQpBRmjXuCamn.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attLLQpBRmjXuCamn.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attLLQpBRmjXuCamn.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Straight Up",
										"year": 2008,
										"medium": "charcoal, pastel and ink on Heritage",
										"dimensions": "74 x 62cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attTvSuEm4f3W8XSM.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attTvSuEm4f3W8XSM.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attTvSuEm4f3W8XSM.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attTvSuEm4f3W8XSM.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attTvSuEm4f3W8XSM.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attTvSuEm4f3W8XSM.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attTvSuEm4f3W8XSM.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attTvSuEm4f3W8XSM.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Something Might Happen",
										"year": 2008,
										"medium": "charcoal, pastel and ink on Heritage",
										"dimensions": "140 x 110cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attoh0ufvBvOhqV1h.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attoh0ufvBvOhqV1h.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attoh0ufvBvOhqV1h.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attoh0ufvBvOhqV1h.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attoh0ufvBvOhqV1h.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attoh0ufvBvOhqV1h.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attoh0ufvBvOhqV1h.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attoh0ufvBvOhqV1h.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Punch Drunk",
										"year": 2006,
										"medium": "charcoal, pastel, ink and varnish on Fabriano",
										"dimensions": "55 x 55cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/att1DjUQJpeTkjdu3.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/att1DjUQJpeTkjdu3.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/att1DjUQJpeTkjdu3.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/att1DjUQJpeTkjdu3.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/att1DjUQJpeTkjdu3.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/att1DjUQJpeTkjdu3.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/att1DjUQJpeTkjdu3.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/att1DjUQJpeTkjdu3.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "King",
										"year": 2006,
										"medium": "charcoal, pastel, ink and varnish on Fabriano",
										"dimensions": "55 x 55cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attfBCnhiLHlXufJc.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attfBCnhiLHlXufJc.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attfBCnhiLHlXufJc.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attfBCnhiLHlXufJc.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attfBCnhiLHlXufJc.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attfBCnhiLHlXufJc.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attfBCnhiLHlXufJc.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attfBCnhiLHlXufJc.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Before I've Seen It All",
										"year": 2006,
										"medium": "charcoal, pastel, ink and varnish on Fabriano",
										"dimensions": "55 x 55cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/atttH9s0t9rWoShJt.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/atttH9s0t9rWoShJt.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/atttH9s0t9rWoShJt.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/atttH9s0t9rWoShJt.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/atttH9s0t9rWoShJt.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/atttH9s0t9rWoShJt.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/atttH9s0t9rWoShJt.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/atttH9s0t9rWoShJt.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Just Because",
										"year": 2006,
										"medium": "charcoal, pastel ink, acrylic and varnish on Fabriano",
										"dimensions": "96 x 96cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attkXUL2CKciCGoRn.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attkXUL2CKciCGoRn.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attkXUL2CKciCGoRn.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attkXUL2CKciCGoRn.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attkXUL2CKciCGoRn.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attkXUL2CKciCGoRn.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attkXUL2CKciCGoRn.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attkXUL2CKciCGoRn.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Schtick",
										"year": 2006,
										"medium": "charcoal, pastel, ink, acrylic and varnish on Fabriano",
										"dimensions": "96 x 96cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attA8JHlGkCaCMzyn.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attA8JHlGkCaCMzyn.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attA8JHlGkCaCMzyn.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attA8JHlGkCaCMzyn.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attA8JHlGkCaCMzyn.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attA8JHlGkCaCMzyn.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attA8JHlGkCaCMzyn.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attA8JHlGkCaCMzyn.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Tip Off",
										"year": 2006,
										"medium": "charcoal, pastel, ink and varnish on Fabriano",
										"dimensions": "55 x 55cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/att63lJ0F4g6EYM3l.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/att63lJ0F4g6EYM3l.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/att63lJ0F4g6EYM3l.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/att63lJ0F4g6EYM3l.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/att63lJ0F4g6EYM3l.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/att63lJ0F4g6EYM3l.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/att63lJ0F4g6EYM3l.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/att63lJ0F4g6EYM3l.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Chi-Chi",
										"year": 2006,
										"medium": "charcoal, pastel, ink and varnish on Fabriano",
										"dimensions": "55 x 55cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attlQwcRetvag2LMS.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attlQwcRetvag2LMS.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attlQwcRetvag2LMS.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attlQwcRetvag2LMS.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attlQwcRetvag2LMS.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attlQwcRetvag2LMS.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attlQwcRetvag2LMS.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attlQwcRetvag2LMS.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Counterpoint",
										"year": 2006,
										"medium": "charcoal, pastel, ink and varnish on Fabriano",
										"dimensions": "55 x 55cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attf5dL3UNvuFmITm.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attf5dL3UNvuFmITm.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attf5dL3UNvuFmITm.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attf5dL3UNvuFmITm.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attf5dL3UNvuFmITm.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attf5dL3UNvuFmITm.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attf5dL3UNvuFmITm.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attf5dL3UNvuFmITm.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Show Pony",
										"year": 2006,
										"medium": "charcoal, pastel, ink and varnish on Fabriano",
										"dimensions": "55 x 55cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attI9MesviTX4d5O5.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attI9MesviTX4d5O5.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attI9MesviTX4d5O5.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attI9MesviTX4d5O5.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attI9MesviTX4d5O5.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attI9MesviTX4d5O5.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attI9MesviTX4d5O5.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attI9MesviTX4d5O5.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Trick",
										"year": 2006,
										"medium": "charcoal, pastel, ink and varnish on Fabriano",
										"dimensions": "55 x 55cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attNdawXm7JpwDfd5.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attNdawXm7JpwDfd5.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attNdawXm7JpwDfd5.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attNdawXm7JpwDfd5.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attNdawXm7JpwDfd5.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attNdawXm7JpwDfd5.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attNdawXm7JpwDfd5.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attNdawXm7JpwDfd5.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Slippery",
										"year": 2006,
										"medium": "charcoal, pastel, ink and varnish on Fabriano",
										"dimensions": "55 x 55cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/att0sJ6YkTyroIZRE.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/att0sJ6YkTyroIZRE.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/att0sJ6YkTyroIZRE.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/att0sJ6YkTyroIZRE.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/att0sJ6YkTyroIZRE.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/att0sJ6YkTyroIZRE.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/att0sJ6YkTyroIZRE.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/att0sJ6YkTyroIZRE.jpg",
																"width": 1366
														}
												]
										}
								}
						],
						"current": false
				},
				{
						"linkName": "preferred-method-paintings",
						"name": "Having and Holding",
						"type": "Painting",
						"copy": "<h2>HAVING AND HOLDING review</h2>\n<p>In\u00a0<i>Having and Holding\u00a0</i>Tony Hull focuses on themes of process and materiality. Through the careful application of colour and mark making he lays bare the process of construction, whilst at the same time implying an act of concealment through a series of barely veiled motifs competing for our attention. On the solidity of canvas supports, or on aluminium surfaces that appear to float across the wall, as viewers we are made strongly aware of the encounter between the agency of the artist and our own gaze.</p>\n<p>The motifs depicted are ubiquitous (tiles, wallpaper and money) and Hull seeks through that ubiquity a sense of neutrality as well as meaning. Money leads us to reflect on the commodification of art, of goods and exchange. As implied by the show title, money can act as a metaphor of (true) love, money, with all its resonance of objects of desire, can substitute love. The act of art imitates the act of love for sale.</p>\n<p>Sometimes the motifs are explicit, at other times the viewer works hard to see them. We might notice after struggling to juggle the receding top layer and emergent underscore, a regal eye and nose, or recognise the childlike flowers that appear with friendly simplicity are the same we handle everyday when exchanging ten pound-notes.</p>\n<p>Surface and depth appear closely intertwined, the layering is at times ambiguous and the surface dislocated. The proximity of these layers threatens to collapse the illusion and there is a sense that things could fall apart visually. Confusion is both encouraged and tolerated.</p>",
						"archive": true,
						"coverImage": {
								"fallbackImageUrl": "https://images.tonyhull.com/1024/attnix85ugyyXQMeZ.jpg",
								"imageSizes": [
										{
												"url": "https://images.tonyhull.com/320/attnix85ugyyXQMeZ.jpg",
												"width": 320
										},
										{
												"url": "https://images.tonyhull.com/768/attnix85ugyyXQMeZ.jpg",
												"width": 768
										},
										{
												"url": "https://images.tonyhull.com/640/attnix85ugyyXQMeZ.jpg",
												"width": 640
										},
										{
												"url": "https://images.tonyhull.com/1024/attnix85ugyyXQMeZ.jpg",
												"width": 1024
										},
										{
												"url": "https://images.tonyhull.com/1600/attnix85ugyyXQMeZ.jpg",
												"width": 1600
										},
										{
												"url": "https://images.tonyhull.com/1920/attnix85ugyyXQMeZ.jpg",
												"width": 1920
										},
										{
												"url": "https://images.tonyhull.com/1366/attnix85ugyyXQMeZ.jpg",
												"width": 1366
										}
								]
						},
						"pieces": [
								{
										"title": "Promise",
										"year": 2004,
										"medium": "oil on canvas",
										"dimensions": "90 x 90cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attm9T3ndmE7A1ozk.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attm9T3ndmE7A1ozk.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attm9T3ndmE7A1ozk.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attm9T3ndmE7A1ozk.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attm9T3ndmE7A1ozk.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attm9T3ndmE7A1ozk.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attm9T3ndmE7A1ozk.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attm9T3ndmE7A1ozk.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Do's and Don'ts",
										"year": 2006,
										"medium": "oil on aluminium",
										"dimensions": "50 x 50cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attrKA2PkpxHYXZgH.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attrKA2PkpxHYXZgH.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attrKA2PkpxHYXZgH.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attrKA2PkpxHYXZgH.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attrKA2PkpxHYXZgH.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attrKA2PkpxHYXZgH.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attrKA2PkpxHYXZgH.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attrKA2PkpxHYXZgH.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Small Print",
										"year": 2004,
										"medium": "oil on canvas",
										"dimensions": "116 x 116cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attOAyw7OB1oCqiTI.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attOAyw7OB1oCqiTI.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attOAyw7OB1oCqiTI.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attOAyw7OB1oCqiTI.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attOAyw7OB1oCqiTI.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attOAyw7OB1oCqiTI.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attOAyw7OB1oCqiTI.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attOAyw7OB1oCqiTI.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Trick",
										"year": 2006,
										"medium": "oil on aluminium",
										"dimensions": "90 x 90cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attVdKJ8iXIYkYJqo.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attVdKJ8iXIYkYJqo.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attVdKJ8iXIYkYJqo.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attVdKJ8iXIYkYJqo.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attVdKJ8iXIYkYJqo.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attVdKJ8iXIYkYJqo.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attVdKJ8iXIYkYJqo.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attVdKJ8iXIYkYJqo.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Cross Purposes",
										"year": 2004,
										"medium": "oil on canvas",
										"dimensions": "116 x 116cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attgsd1jE2gxcS7cS.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attgsd1jE2gxcS7cS.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attgsd1jE2gxcS7cS.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attgsd1jE2gxcS7cS.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attgsd1jE2gxcS7cS.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attgsd1jE2gxcS7cS.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attgsd1jE2gxcS7cS.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attgsd1jE2gxcS7cS.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Tip Off",
										"year": 2006,
										"medium": "oil on aluminium",
										"dimensions": "50 x 50cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attQlLYCN8IDe9uN0.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attQlLYCN8IDe9uN0.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attQlLYCN8IDe9uN0.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attQlLYCN8IDe9uN0.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attQlLYCN8IDe9uN0.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attQlLYCN8IDe9uN0.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attQlLYCN8IDe9uN0.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attQlLYCN8IDe9uN0.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Slippery",
										"year": 2006,
										"medium": "oil on aluminium",
										"dimensions": "61 x 61cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attOJP9pVMneoMhao.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attOJP9pVMneoMhao.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attOJP9pVMneoMhao.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attOJP9pVMneoMhao.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attOJP9pVMneoMhao.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attOJP9pVMneoMhao.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attOJP9pVMneoMhao.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attOJP9pVMneoMhao.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Island",
										"year": 2006,
										"medium": "oil on aluminium",
										"dimensions": "61 x 61cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attNrWuZVocTTxSQq.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attNrWuZVocTTxSQq.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attNrWuZVocTTxSQq.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attNrWuZVocTTxSQq.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attNrWuZVocTTxSQq.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attNrWuZVocTTxSQq.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attNrWuZVocTTxSQq.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attNrWuZVocTTxSQq.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "New Money",
										"year": 2006,
										"medium": "oil on aluminium",
										"dimensions": "50 x 50cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attwoMCDEJCbFYTDj.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attwoMCDEJCbFYTDj.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attwoMCDEJCbFYTDj.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attwoMCDEJCbFYTDj.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attwoMCDEJCbFYTDj.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attwoMCDEJCbFYTDj.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attwoMCDEJCbFYTDj.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attwoMCDEJCbFYTDj.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Devil's  in the Detail",
										"year": 2004,
										"medium": "oil on canvas",
										"dimensions": "116 x 116cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/atteIk4gNkFIKzSFL.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/atteIk4gNkFIKzSFL.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/atteIk4gNkFIKzSFL.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/atteIk4gNkFIKzSFL.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/atteIk4gNkFIKzSFL.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/atteIk4gNkFIKzSFL.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/atteIk4gNkFIKzSFL.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/atteIk4gNkFIKzSFL.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Sequel",
										"year": 2006,
										"medium": "oil on aluminium",
										"dimensions": "50 x 50cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attdlcyOlTt1My4hO.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attdlcyOlTt1My4hO.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attdlcyOlTt1My4hO.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attdlcyOlTt1My4hO.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attdlcyOlTt1My4hO.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attdlcyOlTt1My4hO.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attdlcyOlTt1My4hO.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attdlcyOlTt1My4hO.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Conflict of Interest",
										"year": 2006,
										"medium": "oil on aluminium",
										"dimensions": "50 x 50cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attSjExckmvKiJZmf.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attSjExckmvKiJZmf.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attSjExckmvKiJZmf.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attSjExckmvKiJZmf.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attSjExckmvKiJZmf.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attSjExckmvKiJZmf.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attSjExckmvKiJZmf.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attSjExckmvKiJZmf.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Lost for Words",
										"year": 2006,
										"medium": "oil on aluminium",
										"dimensions": "50 x 50cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attsz5mem7UgK3eu3.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attsz5mem7UgK3eu3.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attsz5mem7UgK3eu3.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attsz5mem7UgK3eu3.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attsz5mem7UgK3eu3.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attsz5mem7UgK3eu3.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attsz5mem7UgK3eu3.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attsz5mem7UgK3eu3.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Real Deal",
										"year": 2006,
										"medium": "oil on aluminium",
										"dimensions": "50 x 50cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/att78xtQlgVsLUty0.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/att78xtQlgVsLUty0.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/att78xtQlgVsLUty0.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/att78xtQlgVsLUty0.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/att78xtQlgVsLUty0.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/att78xtQlgVsLUty0.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/att78xtQlgVsLUty0.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/att78xtQlgVsLUty0.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Counterpoint",
										"year": 2006,
										"medium": "oil on aluminium",
										"dimensions": "50 x 50cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attDI3M9me40lz9Gc.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attDI3M9me40lz9Gc.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attDI3M9me40lz9Gc.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attDI3M9me40lz9Gc.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attDI3M9me40lz9Gc.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attDI3M9me40lz9Gc.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attDI3M9me40lz9Gc.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attDI3M9me40lz9Gc.jpg",
																"width": 1366
														}
												]
										}
								}
						],
						"current": false
				},
				{
						"linkName": "lets-be-millionaires",
						"name": "Let's be Millionaires",
						"type": "Painting",
						"copy": "<h2>LET'S BE MILLIONAIRES</h2>\n<p>Returning to the studio after a challenging period of absence I found myself gravitating towards quite ubiquitous, even banal subjects for painting. On reflection I realise that my choice of flock wallpaper and money as the source material for this series was born of a desire to not focus on the content and meaning of my painting but to allow myself to get lost in the activity itself. Making these works involved a great deal veiling, covering up and, occasionally, an almost nihilistic cancelling out of my brush marks, and yet, almost by stealth, this set of paintings reconnected me with the medium, beginning to make it feel vital again.</p>",
						"archive": true,
						"coverImage": {
								"fallbackImageUrl": "https://images.tonyhull.com/1024/attjJmc0MIyZzuuOw.jpg",
								"imageSizes": [
										{
												"url": "https://images.tonyhull.com/320/attjJmc0MIyZzuuOw.jpg",
												"width": 320
										},
										{
												"url": "https://images.tonyhull.com/768/attjJmc0MIyZzuuOw.jpg",
												"width": 768
										},
										{
												"url": "https://images.tonyhull.com/640/attjJmc0MIyZzuuOw.jpg",
												"width": 640
										},
										{
												"url": "https://images.tonyhull.com/1024/attjJmc0MIyZzuuOw.jpg",
												"width": 1024
										},
										{
												"url": "https://images.tonyhull.com/1600/attjJmc0MIyZzuuOw.jpg",
												"width": 1600
										},
										{
												"url": "https://images.tonyhull.com/1920/attjJmc0MIyZzuuOw.jpg",
												"width": 1920
										},
										{
												"url": "https://images.tonyhull.com/1366/attjJmc0MIyZzuuOw.jpg",
												"width": 1366
										}
								]
						},
						"pieces": [
								{
										"title": "Smother",
										"year": 2003,
										"medium": "oil on canvas",
										"dimensions": "40 x 40cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attERmjuHrlUOfYUV.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attERmjuHrlUOfYUV.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attERmjuHrlUOfYUV.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attERmjuHrlUOfYUV.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attERmjuHrlUOfYUV.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attERmjuHrlUOfYUV.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attERmjuHrlUOfYUV.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attERmjuHrlUOfYUV.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Trace",
										"year": 2003,
										"medium": "oil on canvas",
										"dimensions": "48 x 48cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attJazCpvNAYBa3eo.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attJazCpvNAYBa3eo.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attJazCpvNAYBa3eo.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attJazCpvNAYBa3eo.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attJazCpvNAYBa3eo.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attJazCpvNAYBa3eo.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attJazCpvNAYBa3eo.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attJazCpvNAYBa3eo.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Drench",
										"year": 2003,
										"medium": "oil on canvas",
										"dimensions": "40 x 40cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attbhKR1ni0xvIXWL.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attbhKR1ni0xvIXWL.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attbhKR1ni0xvIXWL.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attbhKR1ni0xvIXWL.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attbhKR1ni0xvIXWL.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attbhKR1ni0xvIXWL.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attbhKR1ni0xvIXWL.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attbhKR1ni0xvIXWL.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Bearer",
										"year": 2003,
										"medium": "oil on canvas",
										"dimensions": "40 x 40cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/atthtub1CwOfZdUaz.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/atthtub1CwOfZdUaz.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/atthtub1CwOfZdUaz.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/atthtub1CwOfZdUaz.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/atthtub1CwOfZdUaz.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/atthtub1CwOfZdUaz.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/atthtub1CwOfZdUaz.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/atthtub1CwOfZdUaz.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Cover Up",
										"year": 2003,
										"medium": "oil on canvas",
										"dimensions": "40 x 40cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/att1ESvoZ9Hb00qgk.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/att1ESvoZ9Hb00qgk.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/att1ESvoZ9Hb00qgk.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/att1ESvoZ9Hb00qgk.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/att1ESvoZ9Hb00qgk.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/att1ESvoZ9Hb00qgk.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/att1ESvoZ9Hb00qgk.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/att1ESvoZ9Hb00qgk.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Deluge",
										"year": 2003,
										"medium": "oil on canvas",
										"dimensions": "40 x 40cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attYtHBojM7PT3T1U.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attYtHBojM7PT3T1U.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attYtHBojM7PT3T1U.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attYtHBojM7PT3T1U.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attYtHBojM7PT3T1U.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attYtHBojM7PT3T1U.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attYtHBojM7PT3T1U.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attYtHBojM7PT3T1U.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Circulation",
										"year": 2003,
										"medium": "oil on canvas",
										"dimensions": "40 x 40cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attPmtn08Ii4hX5yV.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attPmtn08Ii4hX5yV.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attPmtn08Ii4hX5yV.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attPmtn08Ii4hX5yV.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attPmtn08Ii4hX5yV.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attPmtn08Ii4hX5yV.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attPmtn08Ii4hX5yV.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attPmtn08Ii4hX5yV.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Prudence",
										"year": 2003,
										"medium": "oil on canvas",
										"dimensions": "40 x 40cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attsfOsG1rEP3hUlU.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attsfOsG1rEP3hUlU.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attsfOsG1rEP3hUlU.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attsfOsG1rEP3hUlU.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attsfOsG1rEP3hUlU.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attsfOsG1rEP3hUlU.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attsfOsG1rEP3hUlU.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attsfOsG1rEP3hUlU.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Suffocate",
										"year": 2003,
										"medium": "oil on canvas",
										"dimensions": "40 x 40cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attodomxsG8PdN0sN.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attodomxsG8PdN0sN.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attodomxsG8PdN0sN.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attodomxsG8PdN0sN.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attodomxsG8PdN0sN.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attodomxsG8PdN0sN.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attodomxsG8PdN0sN.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attodomxsG8PdN0sN.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "One Trick Pony",
										"year": 2003,
										"medium": "oil on canvas",
										"dimensions": "40 x 40cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attODj1Ri1l2gKWJq.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attODj1Ri1l2gKWJq.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attODj1Ri1l2gKWJq.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attODj1Ri1l2gKWJq.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attODj1Ri1l2gKWJq.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attODj1Ri1l2gKWJq.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attODj1Ri1l2gKWJq.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attODj1Ri1l2gKWJq.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Talisman",
										"year": 2003,
										"medium": "oil on canvas",
										"dimensions": "40 x 40cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attgrDbZ9QXggpynu.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attgrDbZ9QXggpynu.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attgrDbZ9QXggpynu.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attgrDbZ9QXggpynu.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attgrDbZ9QXggpynu.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attgrDbZ9QXggpynu.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attgrDbZ9QXggpynu.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attgrDbZ9QXggpynu.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Another Big Idea",
										"year": 2003,
										"medium": "oil on canvas",
										"dimensions": "40 x 40cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attfeARupC6oPkizn.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attfeARupC6oPkizn.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attfeARupC6oPkizn.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attfeARupC6oPkizn.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attfeARupC6oPkizn.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attfeARupC6oPkizn.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attfeARupC6oPkizn.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attfeARupC6oPkizn.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "The Big Idea",
										"year": 2003,
										"medium": "oil on canvas",
										"dimensions": "40 x 40cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attpxR8AOrKhXVMRX.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attpxR8AOrKhXVMRX.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attpxR8AOrKhXVMRX.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attpxR8AOrKhXVMRX.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attpxR8AOrKhXVMRX.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attpxR8AOrKhXVMRX.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attpxR8AOrKhXVMRX.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attpxR8AOrKhXVMRX.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Reign",
										"year": 2003,
										"medium": "oil on canvas",
										"dimensions": "40 x 40cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attbEZyqPSMNQnn7D.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attbEZyqPSMNQnn7D.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attbEZyqPSMNQnn7D.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attbEZyqPSMNQnn7D.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attbEZyqPSMNQnn7D.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attbEZyqPSMNQnn7D.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attbEZyqPSMNQnn7D.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attbEZyqPSMNQnn7D.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Flock",
										"year": 2003,
										"medium": "oil on canvas",
										"dimensions": "48 x 48cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/att0WmqlRfHs4uB7c.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/att0WmqlRfHs4uB7c.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/att0WmqlRfHs4uB7c.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/att0WmqlRfHs4uB7c.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/att0WmqlRfHs4uB7c.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/att0WmqlRfHs4uB7c.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/att0WmqlRfHs4uB7c.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/att0WmqlRfHs4uB7c.jpg",
																"width": 1366
														}
												]
										}
								}
						],
						"current": false
				},
				{
						"linkName": "virus",
						"name": "Virus",
						"type": "Painting",
						"copy": "<h2>VIRUS</h2>\n<p>This collection of work began as a series of experiments with the chemical qualities of paint. Starting with oil rich mixes, I used the first applications to establish repeated geometric patterns, often with strong lines of symmetry. Once touch-dry, new layers of paint were slowly added, gradually increasing the solvent content. Eventually this caused the first coverings to be reactivated making the original motifs visible again, but only selectively and in quite unexpected ways. The original designs became distorted often creating cell-like structures reminiscent of electron microscopic imaging. The emergence of these new motifs from interactions within the paint itself was what caused me to perceive parallels with the way a virus pirates a cell in order to grow and multiply, and so extend my points of reference.</p>",
						"archive": true,
						"coverImage": {
								"fallbackImageUrl": "https://images.tonyhull.com/1024/attPLEFTz0JbL0jZ1.jpg",
								"imageSizes": [
										{
												"url": "https://images.tonyhull.com/320/attPLEFTz0JbL0jZ1.jpg",
												"width": 320
										},
										{
												"url": "https://images.tonyhull.com/768/attPLEFTz0JbL0jZ1.jpg",
												"width": 768
										},
										{
												"url": "https://images.tonyhull.com/640/attPLEFTz0JbL0jZ1.jpg",
												"width": 640
										},
										{
												"url": "https://images.tonyhull.com/1024/attPLEFTz0JbL0jZ1.jpg",
												"width": 1024
										},
										{
												"url": "https://images.tonyhull.com/1600/attPLEFTz0JbL0jZ1.jpg",
												"width": 1600
										},
										{
												"url": "https://images.tonyhull.com/1920/attPLEFTz0JbL0jZ1.jpg",
												"width": 1920
										},
										{
												"url": "https://images.tonyhull.com/1366/attPLEFTz0JbL0jZ1.jpg",
												"width": 1366
										}
								]
						},
						"pieces": [
								{
										"title": "Sandman",
										"year": 2000,
										"medium": "oil on canvas",
										"dimensions": "150 150cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attM92oPA4jDy2b8p.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attM92oPA4jDy2b8p.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attM92oPA4jDy2b8p.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attM92oPA4jDy2b8p.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attM92oPA4jDy2b8p.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attM92oPA4jDy2b8p.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attM92oPA4jDy2b8p.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attM92oPA4jDy2b8p.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Inhale",
										"year": 2000,
										"medium": "oil on cnvas",
										"dimensions": "150 x 150cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/att57yHW9utJVHVUg.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/att57yHW9utJVHVUg.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/att57yHW9utJVHVUg.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/att57yHW9utJVHVUg.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/att57yHW9utJVHVUg.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/att57yHW9utJVHVUg.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/att57yHW9utJVHVUg.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/att57yHW9utJVHVUg.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Abscision",
										"year": 2000,
										"medium": "oil on canvas",
										"dimensions": "150 x 150cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attZEoFFzGDYSA2LF.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attZEoFFzGDYSA2LF.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attZEoFFzGDYSA2LF.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attZEoFFzGDYSA2LF.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attZEoFFzGDYSA2LF.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attZEoFFzGDYSA2LF.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attZEoFFzGDYSA2LF.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attZEoFFzGDYSA2LF.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Iodine",
										"year": 2000,
										"medium": "oil on canvas",
										"dimensions": "173 x 148cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attWCC62jMOihs3zu.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attWCC62jMOihs3zu.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attWCC62jMOihs3zu.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attWCC62jMOihs3zu.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attWCC62jMOihs3zu.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attWCC62jMOihs3zu.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attWCC62jMOihs3zu.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attWCC62jMOihs3zu.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Foreign Body",
										"year": 2000,
										"medium": "oil on canvas",
										"dimensions": "150 x 150cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attuwHw5wpGRjpy1X.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attuwHw5wpGRjpy1X.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attuwHw5wpGRjpy1X.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attuwHw5wpGRjpy1X.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attuwHw5wpGRjpy1X.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attuwHw5wpGRjpy1X.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attuwHw5wpGRjpy1X.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attuwHw5wpGRjpy1X.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Causal",
										"year": 2000,
										"medium": "oil on canvas",
										"dimensions": "92 x 92cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attBvCYQjuGzwKn1v.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attBvCYQjuGzwKn1v.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attBvCYQjuGzwKn1v.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attBvCYQjuGzwKn1v.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attBvCYQjuGzwKn1v.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attBvCYQjuGzwKn1v.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attBvCYQjuGzwKn1v.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attBvCYQjuGzwKn1v.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Smudge",
										"year": 2000,
										"medium": "oil on canvas",
										"dimensions": "30 x 30cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/att8k0vHilve5PVd0.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/att8k0vHilve5PVd0.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/att8k0vHilve5PVd0.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/att8k0vHilve5PVd0.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/att8k0vHilve5PVd0.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/att8k0vHilve5PVd0.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/att8k0vHilve5PVd0.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/att8k0vHilve5PVd0.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Corrupt",
										"year": 2000,
										"medium": "oil on canvas",
										"dimensions": "63 x 63 cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attUQVFUmpvN6A5Li.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attUQVFUmpvN6A5Li.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attUQVFUmpvN6A5Li.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attUQVFUmpvN6A5Li.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attUQVFUmpvN6A5Li.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attUQVFUmpvN6A5Li.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attUQVFUmpvN6A5Li.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attUQVFUmpvN6A5Li.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Spread",
										"year": 1999,
										"medium": "oil on canvas",
										"dimensions": "63 x 63cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attmP1VYFUHRyG4vI.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attmP1VYFUHRyG4vI.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attmP1VYFUHRyG4vI.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attmP1VYFUHRyG4vI.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attmP1VYFUHRyG4vI.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attmP1VYFUHRyG4vI.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attmP1VYFUHRyG4vI.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attmP1VYFUHRyG4vI.jpg",
																"width": 1366
														}
												]
										}
								},
								{
										"title": "Germ",
										"year": 2000,
										"medium": "oil on canvas",
										"dimensions": "63 x 63cm",
										"image": {
												"fallbackImageUrl": "https://images.tonyhull.com/1024/attRjt6oXWwfbAYoO.jpg",
												"imageSizes": [
														{
																"url": "https://images.tonyhull.com/320/attRjt6oXWwfbAYoO.jpg",
																"width": 320
														},
														{
																"url": "https://images.tonyhull.com/768/attRjt6oXWwfbAYoO.jpg",
																"width": 768
														},
														{
																"url": "https://images.tonyhull.com/640/attRjt6oXWwfbAYoO.jpg",
																"width": 640
														},
														{
																"url": "https://images.tonyhull.com/1024/attRjt6oXWwfbAYoO.jpg",
																"width": 1024
														},
														{
																"url": "https://images.tonyhull.com/1600/attRjt6oXWwfbAYoO.jpg",
																"width": 1600
														},
														{
																"url": "https://images.tonyhull.com/1920/attRjt6oXWwfbAYoO.jpg",
																"width": 1920
														},
														{
																"url": "https://images.tonyhull.com/1366/attRjt6oXWwfbAYoO.jpg",
																"width": 1366
														}
												]
										}
								}
						],
						"current": false
				}
		],
		"pages": [
				{
						"name": "Mentoring and Tutorial Support",
						"slug": "mentoring",
						"content": "<p>Tony Hull is a well loved and renowned fine art tutor and authority on drawing. He has taught at various art schools including Central Saint Martin\u2019s, Manchester Met and Gloucestershire School of Arts working on both MA and BA programmes. He is currently a lead tutor in Fine Art at the City Lit Institute in London on the Extended Practice Programme.</p>\n<p>Additionally Tony has written and delivered various workshop programmes relating to critique and the creative process, all built around a central drawing component. He has run these worldwide for companies such as Electronic Arts, Vanguard Animation (UK), Tell Me (San Francisco), Kaos Studios/THQ (New York), Microsoft, and Microsoft Research Asia (Beijing).</p>\n<p>On a one to one basis, he has taught drawing to renowned opera, television and film directors (NDAs duly signed), as well as numerous artists, architects, animators, designers and creatives.</p>\n<p>He has also been involved in online one to one mentoring for some time, working with artists (some in the formative stages of their careers) to offer mentoring, tutorial feedback, critique and studio support as necessary.</p>\n<p></p>\n<h2>Testimonials</h2>\n<p><i>Tony Hull is an outstanding teacher and mentor. He has the unusual ability to decipher and interpret what a student \u2013 whether beginner or advanced \u2013 is trying to realise and, through a detailed process of insight, analysis, dialogue and advice, help them to achieve more than they thought possible. I am now completing a 2-year part-time MA in Fine Art at Middlesex University, having only started painting a few years ago. This achievement is due in no small part to Tony\u2019s thoughtful, generous and insightful teaching and mentoring.</i></p>\n<p>Kathy Rooney</p>\n<p></p>\n<p><i>I feel honoured to be one of Tony's mentees, his background, training and years of experience encouraging artists, mixed with his own art practice gives him an ability to give incredibly insightful, helpful and\u00a0spot on\u00a0advice, especially when my head gets in a creative whirlpool of managing a sometimes overwhelming schedule of exhibitions, creative output, on top of\u2026 life! It\u2019s like weekly therapy for my art practice/ business. I cannot recommend Tony enough.\u00a0</i></p>\n<p>Amy Gardner</p>\n<p></p>\n<p><i>Unable to grasp the technical side of drawing and painting, I signed up for a class with Tony. His clear guidance and immense patience allowed me quickly to pick up details not grasped at art school. With a view to returning to some semblance of a fine art practice, last summer I asked Tony to be my art mentor. To my complete surprise, not only did he inspire me to produce a body of work from a small idea, he encouraged me to begin the process of \u201cmaking\u201d again.\u00a0\n\nDuring our weekly zoom calls during which we discuss my \u201cmaking\u201d, I value his non-judgemental but to-the-point opinion. Setting him apart from any teacher I\u2019ve met before, from a Friday art class to considering applying for an MA in Fine Art, Tony is an inspiration. I think he\u2019s extraordinary.</i></p>\n<p>Stacey Duguid</p>\n<p></p>\n<p><i>Tony has really helped me see things in my work\u00a0that I may not see, which has allowed me to work\u00a0with my strengths and develop my painting\u00a0practice further. His enthusiasm and encouraging manner, along\u00a0with his expertise in the arts, is what has really helped push my work along and has opened up new creative opportunities that I find much more enjoyable.</i>\u00a0</p>\n<p>Jennifer Louise Martin</p>\n<p></p>"
				},
				{
						"name": "Podcast",
						"slug": "podcast",
						"content": "<h2>PROCESSING TRAUMA THROUGH DRAWING</h2>\n<p>This podcast series, funded by an\u00a0<a href=\"https://www.artscouncil.org.uk/\" target=\"_blank\">Arts Council England</a>\u00a0Project Award, intends to unpack strands of my ongoing research into how the act of drawing might help in processing difficult, traumatic events. Initiated by personal experience, in each episode I will explore a different element of the visual, motor, cognitive and psychological aspects potentially involved. Overall, the structure of this series will be led by the research, evolving to an extent in 'real-time' in response to my findings, reflections, and interviews with experts in the field.</p>"
				},
				{
						"name": "Contact",
						"slug": "contact",
						"content": "<p>Feel free to get in touch about my work, writing/talks/mentoring/tutoring or to register an interest in the developing Podcast series.</p>",
						"image": {
								"fallbackImageUrl": "https://images.tonyhull.com/1024/5Lw7cE1nNLRhC1eHsbQWsQ.jpg",
								"imageSizes": [
										{
												"url": "https://images.tonyhull.com/320/5Lw7cE1nNLRhC1eHsbQWsQ.jpg",
												"width": 320
										},
										{
												"url": "https://images.tonyhull.com/768/5Lw7cE1nNLRhC1eHsbQWsQ.jpg",
												"width": 768
										},
										{
												"url": "https://images.tonyhull.com/640/5Lw7cE1nNLRhC1eHsbQWsQ.jpg",
												"width": 640
										},
										{
												"url": "https://images.tonyhull.com/1024/5Lw7cE1nNLRhC1eHsbQWsQ.jpg",
												"width": 1024
										},
										{
												"url": "https://images.tonyhull.com/1600/5Lw7cE1nNLRhC1eHsbQWsQ.jpg",
												"width": 1600
										},
										{
												"url": "https://images.tonyhull.com/1920/5Lw7cE1nNLRhC1eHsbQWsQ.jpg",
												"width": 1920
										},
										{
												"url": "https://images.tonyhull.com/1366/5Lw7cE1nNLRhC1eHsbQWsQ.jpg",
												"width": 1366
										}
								]
						}
				},
				{
						"name": "Writing",
						"slug": "writing",
						"content": "<p>My first book,\u00a0<i>Drawing: Adventures in Seeing Creatively</i>, deals with the relationship between drawing and visual perception. It explores the idea of seeing as thinking, how drawing can spark more imaginative responses to vision to initiate quite unexpected ways of conceiving the world. The practice of drawing is presented as a gateway activity, one capable of shaping an all-encompassing change of perspective with applications across numerous disciplines.</p>\n<p>Learning to draw is about more than the acquisition of a skill set. It offers a potentially revelatory window onto perception. Unlike other instructive drawing books, this title considers the philosophical insights triggered by the activity to explain why the interpretation of vision changes so markedly. It reveals the brain to be susceptible to very predictable patterns of thought and demonstrates how drawing can disrupt these to create new links and pathways allowing the familiar to be seen in a completely new light.</p>\n<p>Nine detailed drawing exercises enable this to happen. Throughout, the style of drawing is unfussy and straightforward so that the projects are always accessible. Exercises are designed to be approachable for readers new to drawing, yet \u2018open\u2019 enough to stretch those with prior experience. Each drawing is followed by a reflective passage weighing up its implications and, where necessary, touching on relevant theories of perception. The book traces a gentle philosophical arc to a place where you aren\u2019t simply recording what you see, but where drawing actually becomes instrumental in shaping and re-shaping your vision and imagination. And by placing drawing within the routine fabric of life (each sketch is carried out at the kitchen table) the book clearly demonstrates drawing\u2019s capacity to transform the ubiquitous into something altogether less predictable.</p>\n<p><i>Through a series of precise steps, this book shows how the action and experience of drawing can be revelatory. Drawing is shown as a practice for recalibrating our ability to see and make present, in ways that are as accessible as they are profound. This book enables the conditions under which creative thought can happen, as an openness to the possible and the new.</i></p>\n<p>Jean Boyd, Senior Lecturer at the School of Arts, University of Gloucestershire</p>\n<p><a href=\"/files/TonyHullAdventuresInSeeingCreativelyExcerptSite.pdf\" target=\"_blank\"><i>Drawing: Adventures in Seeing Creatively</i>\u00a0book extract</a></p>",
						"image": {
								"fallbackImageUrl": "https://images.tonyhull.com/1024/4xHz2e2irMh1TKIIGDfFuw.jpg",
								"imageSizes": [
										{
												"url": "https://images.tonyhull.com/320/4xHz2e2irMh1TKIIGDfFuw.jpg",
												"width": 320
										},
										{
												"url": "https://images.tonyhull.com/768/4xHz2e2irMh1TKIIGDfFuw.jpg",
												"width": 768
										},
										{
												"url": "https://images.tonyhull.com/640/4xHz2e2irMh1TKIIGDfFuw.jpg",
												"width": 640
										},
										{
												"url": "https://images.tonyhull.com/1024/4xHz2e2irMh1TKIIGDfFuw.jpg",
												"width": 1024
										},
										{
												"url": "https://images.tonyhull.com/1600/4xHz2e2irMh1TKIIGDfFuw.jpg",
												"width": 1600
										},
										{
												"url": "https://images.tonyhull.com/1920/4xHz2e2irMh1TKIIGDfFuw.jpg",
												"width": 1920
										},
										{
												"url": "https://images.tonyhull.com/1366/4xHz2e2irMh1TKIIGDfFuw.jpg",
												"width": 1366
										}
								],
								"description": "Drawing: Adventures in Seeing Creatively"
						},
						"imageCaption": "<p>Image from\u00a0<i>Drawing: Adventures in Seeing Creatively</i></p>"
				},
				{
						"name": "Bio",
						"slug": "bio",
						"content": "<p>Tony Hull is a visual artist based in London. He uses film, photography and performance as an impetus for drawing and painting. He\u2019s intrigued by the way the object of a painting affects its interpretation, leading to experiments with different kinds of support, most recently using oil paint itself in the form of tablet.</p>\n<p>Tony trained at Manchester School of Art, Chelsea School of Art and then the Slade School at University College London for Post Grad.</p>\n<p>Tony\u2019s work has been exhibited around the UK and in Europe including solo shows at Andrew Lesley Gallery in Antwerp, Northbank and Hope Galleries in London, and Opus Fine Art in Gloucestershire. He\u2019s shown at Angela Flowers, Stephen Lacey, Jagged Art, Mall Gallery, Royal Festival Hall in London, Opus in Newcastle and Whitworth Art Gallery in Manchester. He has had solo exhibitions in several London Research Institutions: Royal College of Pathologists, several shows at the Institute of Child Health, and the London Centre for Psychotherapy. His work has been featured in a British Council Print Exhibition touring Pakistan. Tony\u2019s paintings have also been regularly shown in the Threadneedle Prize Exhibition and the Whitechapel Open, and he has taken part in (and curated) several shows at Derbyshire Projects Space London. His collaboration with the poet Paul Stevenson as part of the Albert Project culminated in the exhibition\u00a0<i>Pistons and Pollinators</i>. His paintings sell widely and are in many private collections in both Europe and the US. His work is also featured in\u00a0<i>Drawing and Painting</i>\u00a0by Kate Wilson (Thames and Hudson, 2015).</p>\n<p>Over the years Tony has taught MA and BA Fine Art at various English Art Schools, including Manchester and Gloucestershire Schools of Art, and drawing practice at Central St Martins. He is currently a lead tutor in Fine Art within Extended Practice Area at the City Lit in London. As a freelance consultant he has run life drawing sessions for creative professionals in many settings including a year long programme for animators at Ealing Studios during the production of the film\u00a0<i>Valiant</i>. His trust in drawing as a creative catalyst has led to numerous drawing workshops investigating its potential in London, New York, San Fransisco, Seattle and Beijing. This was the subject of his first book,\u00a0<i>Drawing: Adventures in Seeing Creatively</i>, which explores the relationship between drawing, visual perception and the creative impetus. He is currently researching a second book looking at ways in which the body processes experience through drawing.</p>\n<p>Tony is a member of the Park Studios Co-op where he shows bi-annually.</p>"
				}
		]
}